import { __decorate } from 'tslib';
import { stringify } from 'qs';
import deepmerge from 'deepmerge';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

// usage:
//   `new Factory(type).build(id, attributes, relationships);`
var Factory = /*#__PURE__*/function () {
  function Factory(type) {
    this.type = type;
  }

  Factory.register = function register(type, Class) {
    this.TYPES[type] = Class;
  } // relationships should be of type RelatedModels, but that requires Base,
  // which would cause a circular dependency
  ;

  var _proto = Factory.prototype;

  _proto.build = function build(id, attributes, relationships) {
    var ModelClass = Factory.TYPES[this.type] || Factory.FallbackType;

    if (!ModelClass) {
      throw new Error('No fallback class was defined. (protip: include Unknown)');
    }

    return new ModelClass(id, attributes, relationships);
  };

  return Factory;
}();
Factory.TYPES = {};

//
// Specialized Error Classes
//
var GodmotherError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(GodmotherError, _Error);

  function GodmotherError(message) {
    var _this;

    // extending native classes often breaks the prototype chain
    _this = _Error.call(this, message) || this; // ...so we explicitly restore prototype chain (example provided by)

    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof GodmotherError ? this.constructor : void 0).prototype);
    _this.name = _this.constructor.name;
    return _this;
  }

  return GodmotherError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var ResponseError = /*#__PURE__*/function (_GodmotherError) {
  _inheritsLoose(ResponseError, _GodmotherError);

  function ResponseError(message, response, code, title, meta) {
    var _this2;

    _this2 = _GodmotherError.call(this, message) || this;
    _this2.response = response;
    _this2.code = code;
    _this2.title = title;
    _this2.meta = meta;
    return _this2;
  }

  ResponseError.throwFromResponse = /*#__PURE__*/function () {
    var _throwFromResponse = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(response) {
      var errorText, errorCode, errorTitle, errorMeta, ErrorClass, errorTextJson, objectOrString, _objectOrString$error, _objectOrString$error2, _objectOrString$error3, _objectOrString$error4, _objectOrString$error5, _objectOrString$error6;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              errorCode = null, errorTitle = null, errorMeta = null;
              ErrorClass = ResponseError.getErrorClass(response);
              _context.prev = 2;
              _context.next = 5;
              return response.text();

            case 5:
              errorTextJson = _context.sent;
              objectOrString = JSON.parse(errorTextJson);

              if (objectOrString instanceof Object && !(objectOrString instanceof Array)) {
                /**
                 * if godmother gave errors (which may or may not be due to a 500),
                 * let's surface them so they can be used
                 */
                if (objectOrString != null && (_objectOrString$error = objectOrString.errors) != null && (_objectOrString$error2 = _objectOrString$error[0]) != null && _objectOrString$error2.code) {
                  errorCode = objectOrString.errors[0].code;
                }

                if (objectOrString != null && (_objectOrString$error3 = objectOrString.errors) != null && (_objectOrString$error4 = _objectOrString$error3[0]) != null && _objectOrString$error4.title) {
                  errorTitle = objectOrString.errors[0].title;
                }

                if (objectOrString != null && (_objectOrString$error5 = objectOrString.errors) != null && (_objectOrString$error6 = _objectOrString$error5[0]) != null && _objectOrString$error6.meta) {
                  errorMeta = objectOrString.errors[0].meta;
                }

                errorText = objectOrString.error;
              }

              errorText = errorText || objectOrString;
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              errorText = response.statusText;

            case 14:
              throw new ErrorClass(errorText, response, errorCode, errorTitle, errorMeta);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    function throwFromResponse(_x) {
      return _throwFromResponse.apply(this, arguments);
    }

    return throwFromResponse;
  }();

  ResponseError.getErrorClass = function getErrorClass(response) {
    if (response.status === 401) return AuthenticationResponseError;
    if (response.status === 403) return AuthorizationResponseError;
    return ResponseError;
  };

  return ResponseError;
}(GodmotherError);
var AuthenticationResponseError = /*#__PURE__*/function (_ResponseError) {
  _inheritsLoose(AuthenticationResponseError, _ResponseError);

  function AuthenticationResponseError() {
    return _ResponseError.apply(this, arguments) || this;
  }

  return AuthenticationResponseError;
}(ResponseError);
var AuthorizationResponseError = /*#__PURE__*/function (_ResponseError2) {
  _inheritsLoose(AuthorizationResponseError, _ResponseError2);

  function AuthorizationResponseError() {
    return _ResponseError2.apply(this, arguments) || this;
  }

  return AuthorizationResponseError;
}(ResponseError);

// TODO: break up this file
var Base_1;

function defaultFetch(url, options) {
  return window.fetch(url, options);
} // exported for testing with _ prefix to suggest it should not be used

function checkStatus(_x) {
  return _checkStatus2.apply(this, arguments);
} // exported for testing with _ prefix to suggest it should not be used


function _checkStatus2() {
  _checkStatus2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(response) {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (response) {
              _context.next = 2;
              break;
            }

            throw new GodmotherError('No response');

          case 2:
            if (!(response.status < 200 || response.status >= 300)) {
              _context.next = 5;
              break;
            }

            _context.next = 5;
            return ResponseError.throwFromResponse(response);

          case 5:
            return _context.abrupt("return", response);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _checkStatus2.apply(this, arguments);
}

function parseJson(_x2) {
  return _parseJson.apply(this, arguments);
}

function _parseJson() {
  _parseJson = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(response) {
    var text;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return response.text();

          case 2:
            text = _context2.sent;
            return _context2.abrupt("return", text ? JSON.parse(text) : null);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _parseJson.apply(this, arguments);
}

function staticImplements() {
  return function (constructor) {
    return constructor;
  }; // tslint:disable-line no-unused-expression
}
var RestActions = {
  List: 'list',
  Create: 'create',
  Find: 'find',
  Save: 'save',
  Destroy: 'destroy'
};
var GODMOTHER_HEADERS = {
  Accept: 'application/vnd.api+json',
  'Accept-Charset': 'UTF-8',
  'Content-Type': 'application/vnd.api+json;charset=UTF-8'
};

var Base = Base_1 = /*#__PURE__*/function () {
  function Base(id, attributes, relationships) {
    this.id = id;
    this.assignAttributes(attributes);
    this.assignRelationships(relationships);
  }

  Base.configureAdapter = function configureAdapter(_ref) {
    var baseUrl = _ref.baseUrl,
        defaultOptions = _ref.defaultOptions,
        _ref$fetch = _ref.fetch,
        fetch = _ref$fetch === void 0 ? defaultFetch : _ref$fetch,
        middleware = _ref.middleware,
        _ref$queryStringOptio = _ref.queryStringOptions,
        queryStringOptions = _ref$queryStringOptio === void 0 ? {
      encodeValuesOnly: true
    } : _ref$queryStringOptio;
    this.baseUrl = baseUrl;
    this.defaultOptions = this.applyDefaultOptions(defaultOptions);
    this.fetch = fetch;
    this.middleware = middleware;
    this.queryStringOptions = queryStringOptions;
  };

  Base.setAuthToken = function setAuthToken(token) {
    if (!this.defaultOptions) this.defaultOptions = {};
    if (!this.defaultOptions.headers) this.defaultOptions.headers = {};
    this.defaultOptions.headers.Authorization = "Bearer " + token;
  };

  Base.applyMiddleware = function applyMiddleware(key, middleware) {
    if (!this.middleware) this.middleware = {};
    this.middleware[key] = middleware;
  } //////////////////////
  //                  //
  //   REST methods   //
  //                  //
  //////////////////////
  ;

  Base.list = function list(params, options) {
    var url = this.getCollectionUrl(params);
    var requestOptions = this.getOptions(_extends({}, options, {
      method: 'GET'
    }));
    return this.applyMiddlewareToFetch(RestActions.List, url, requestOptions).then(parseJson).then(this.fromResponse.bind(this));
  };

  Base.create = function create(attributes, options) {
    // some of our GM POST endpoints expect query params, so let's make sure they're accounted for here
    var url = this.getCollectionUrl((options == null ? void 0 : options.params) || {});

    if (options != null && options.params) {
      delete options.params;
    }

    var payload = {
      data: {
        type: this.type,
        attributes: attributes
      }
    };
    var requestOptions = this.getOptions(_extends({}, options, {
      body: JSON.stringify(payload),
      method: 'POST'
    }));
    return this.applyMiddlewareToFetch(RestActions.Create, url, requestOptions).then(parseJson).then(this.fromResponse.bind(this));
  };

  Base.find = function find(id, options) {
    var url = this.getMemberUrl(id);
    var requestOptions = this.getOptions(_extends({}, options, {
      method: 'GET'
    }));
    return this.applyMiddlewareToFetch(RestActions.Find, url, requestOptions).then(parseJson).then(this.fromResponse.bind(this));
  };

  var _proto = Base.prototype;

  _proto.destroy = function destroy(options, params) {
    var ctor = this.constructor;
    var url = ctor.getMemberUrl(this.id, params);
    var requestOptions = ctor.getOptions(_extends({}, options, {
      method: 'DELETE'
    }));
    return ctor.applyMiddlewareToFetch(RestActions.Destroy, url, requestOptions);
  } // TODO: save (an instance method), unlike find, list, and create (static
  // methods), always returns an instance of Base, not the type provided. The
  // primary API of save should be to update the instance upon which it was
  // called,so it's ok that this doesn't work, but it would be nice to also
  // return an instance for further chaining (also because this instance could
  // have been updated elsewhere since the instance was created)
  ;

  _proto.save = function save(attributes, options) {
    var _this = this;

    var ctor = this.constructor;
    var url = ctor.getMemberUrl(this.id);
    var payload = {
      data: {
        type: ctor.type,
        attributes: attributes
      }
    };
    var requestOptions = ctor.getOptions(_extends({}, options, {
      body: JSON.stringify(payload),
      method: 'PATCH'
    }));
    var promise = ctor.applyMiddlewareToFetch(RestActions.Save, url, requestOptions).then(parseJson).then(ctor.fromResponse.bind(ctor));
    promise.then(function (model) {
      if (model && !Array.isArray(model)) {
        _this.assignAttributes(model);

        _this.assignRelationships(model);
      }

      return model;
    });
    return promise;
  } ////////////////
  //            //
  //   public   //
  //            //
  ////////////////
  ;

  Base.getCollectionUrl = function getCollectionUrl(params) {
    var url = "" + this.baseUrl + this.collectionPath;

    if (params) {
      url += "?" + stringify(params, this.queryStringOptions);
    }

    return url;
  };

  Base.getMemberUrl = function getMemberUrl(id, params) {
    var url = "" + this.baseUrl + this.collectionPath + "/" + id;

    if (params) {
      url += "?" + stringify(params, this.queryStringOptions);
    }

    return url;
  } ///////////////////
  //               //
  //   protected   //
  //               //
  ///////////////////
  ;

  Base.getOptions = function getOptions(options) {
    // we occasionally need to pass a Request object to middleware so that client-side cookies can be passed along to Godmother.
    // deepmerging the request object causes problems
    var clientRequest = options.request;
    delete options.request; // Deep merge so we don't override this.defaultOptions, unless we explicitly pass in options with overrides

    return _extends({}, deepmerge(this.defaultOptions || {}, options), {
      request: clientRequest
    });
  };

  Base.applyMiddlewareToFetch = function applyMiddlewareToFetch(method, url, options) {
    var _this2 = this;

    var appliedFetch;

    if (!this.middleware) {
      // no Middleware to be applied
      appliedFetch = this.fetch;
    } else {
      // create a Middleware Onion
      appliedFetch = Object.values(this.middleware).reduce(function (f, fnMiddleware) {
        return fnMiddleware(_this2, method, f);
      }, this.fetch);
    }

    return appliedFetch(url, options).then(checkStatus); // .catch(this._handleAbort); // TODO: implement request cancelling
  };

  Base.lookupKey = function lookupKey(type, id) {
    return type + ":" + id;
  };

  Base.fromResponse = function fromResponse(response) {
    var _this3 = this;

    var _ref2 = response || {},
        data = _ref2.data,
        meta = _ref2.meta,
        included = _ref2.included;

    if (!data) return;
    var includedMap = included == null ? void 0 : included.reduce(function (hash, include) {
      var includeId = include.id,
          includeType = include.type;
      hash[_this3.lookupKey(includeType, includeId)] = include;
      return hash;
    }, {});

    if (Array.isArray(data)) {
      var models = data.filter(function (d) {
        return d;
      }).map(function (d) {
        return _this3.fromData(d, includedMap);
      });
      return ListEnvelope.fromArray(models, meta);
    }

    return this.fromData(data, includedMap);
  };

  Base.fromData = function fromData(data, includedMap) {
    var _this4 = this;

    // should only be `AbstractInstanceType<T> | undefined`
    if (!data) return;
    var id = data.id,
        type = data.type,
        attributes = data.attributes,
        _data$relationships = data.relationships,
        relationships = _data$relationships === void 0 ? {} : _data$relationships;
    var related = Object.keys(relationships).reduce(function (hash, key) {
      var relationshipData = relationships[key].data;

      if (Array.isArray(relationshipData)) {
        hash[key] = relationshipData.map(function (_ref3) {
          var dataId = _ref3.id,
              dataType = _ref3.type;
          return _this4.getIncludedData(dataType, dataId, includedMap);
        });
      } else if (relationshipData) {
        var dataId = relationshipData.id,
            dataType = relationshipData.type;
        hash[key] = _this4.getIncludedData(dataType, dataId, includedMap);
      }

      return hash;
    }, {});
    return new Factory(type).build(id, attributes, related);
  };

  Base.getIncludedData = function getIncludedData(type, id, includedMap) {
    var key = this.lookupKey(type, id);
    var data = includedMap && includedMap[key] || {
      id: id,
      type: type
    };
    return this.fromData(data, includedMap);
  } /////////////////
  //             //
  //   private   //
  //             //
  /////////////////
  ;

  Base.applyDefaultOptions = function applyDefaultOptions(options) {
    var defaultOptions = _extends({}, options);

    var _defaultOptions$heade = defaultOptions.headers,
        defaultHeaders = _defaultOptions$heade === void 0 ? {} : _defaultOptions$heade;
    defaultOptions.headers = _extends({}, GODMOTHER_HEADERS, defaultHeaders);
    return defaultOptions;
  };

  return Base;
}();

Base.type = '';
Base.collectionPath = '';
Base = Base_1 = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Base);
var Base$1 = Base; // I'd put this in it's own file, but I'm sure it would lead to a circular
// dependency
// the ListEnvelope acts like an array, but has the additional meta property

var ListEnvelope = /*#__PURE__*/function (_Array) {
  _inheritsLoose(ListEnvelope, _Array);

  function ListEnvelope() {
    var _this5;

    for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
      items[_key] = arguments[_key];
    }

    _this5 = _Array.call.apply(_Array, [this].concat(items)) || this;
    _this5.meta = {};
    Object.setPrototypeOf(_assertThisInitialized(_this5), Object.create(ListEnvelope.prototype));
    return _this5;
  }

  ListEnvelope.fromArray = function fromArray(models, meta) {
    var envelope = _construct(ListEnvelope, models);

    envelope.meta = meta;
    return envelope;
  };

  return ListEnvelope;
}( /*#__PURE__*/_wrapNativeSuper(Array));

var Activity = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Activity, _Base);

  function Activity() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Activity.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.styleName = attributes.styleName;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Activity;
}(Base$1);

Activity.type = 'activity';
Activity.collectionPath = '/activities';
Activity = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Activity);
var Activity$1 = Activity;
Factory.register(Activity.type, Activity);

var Address = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Address, _Base);

  function Address() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Address.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.addressName = attributes.addressName;
    this.addressType = attributes.addressType;
    this.city = attributes.city;
    this.company = attributes.company;
    this["default"] = attributes["default"];
    this.firstName = attributes.firstName;
    this.lastName = attributes.lastName;
    this.phone = attributes.phone;
    this.postalCode = attributes.postalCode;
    this.street1 = attributes.street1;
    this.street2 = attributes.street2;
    this.userId = attributes.userId;
    this.zoneCode = attributes.zoneCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.user = relationships.user;
  };

  return Address;
}(Base$1);

Address.type = 'address';
Address.collectionPath = '/addresses';
Address = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Address);
var Address$1 = Address;
Factory.register(Address.type, Address);

var AddressSuggestion = /*#__PURE__*/function (_Base) {
  _inheritsLoose(AddressSuggestion, _Base);

  function AddressSuggestion() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = AddressSuggestion.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.addressType = attributes.addressType;
    this.city = attributes.city;
    this.reason = attributes.reason;
    this.state = attributes.state;
    this.street = attributes.street;
    this.unit = attributes.unit;
    this.zip = attributes.zip;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return AddressSuggestion;
}(Base$1);

AddressSuggestion.type = 'addressSuggestion';
AddressSuggestion.collectionPath = '/addressSuggestions';
AddressSuggestion = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], AddressSuggestion);
var AddressSuggestion$1 = AddressSuggestion;
Factory.register(AddressSuggestion.type, AddressSuggestion);

var AdvocateAwardStatus = /*#__PURE__*/function (_Base) {
  _inheritsLoose(AdvocateAwardStatus, _Base);

  function AdvocateAwardStatus() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = AdvocateAwardStatus.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.awardProgress = attributes.awardProgress;
    this.awards = attributes.awards;
    this.reward = attributes.reward;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return AdvocateAwardStatus;
}(Base$1);

AdvocateAwardStatus.type = 'advocateAwardStatus';
AdvocateAwardStatus.collectionPath = '/advocateAwardStatuses';
AdvocateAwardStatus = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], AdvocateAwardStatus);
var AdvocateAwardStatus$1 = AdvocateAwardStatus;
Factory.register(AdvocateAwardStatus.type, AdvocateAwardStatus);

var AdvocateEligibility = /*#__PURE__*/function (_Base) {
  _inheritsLoose(AdvocateEligibility, _Base);

  function AdvocateEligibility() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = AdvocateEligibility.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.endsAt = attributes.endsAt;
    this.expiresAt = attributes.expiresAt;
    this.startsAt = attributes.startsAt;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.programRule = relationships.programRule;
  };

  return AdvocateEligibility;
}(Base$1);

AdvocateEligibility.type = 'advocateEligibility';
AdvocateEligibility.collectionPath = '/advocateEligibilities';
AdvocateEligibility = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], AdvocateEligibility);
var AdvocateEligibility$1 = AdvocateEligibility;
Factory.register(AdvocateEligibility.type, AdvocateEligibility);

var AdvocateProgramStatus = /*#__PURE__*/function (_Base) {
  _inheritsLoose(AdvocateProgramStatus, _Base);

  function AdvocateProgramStatus() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = AdvocateProgramStatus.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.programType = attributes.programType;
    this.remainingRedemptions = attributes.remainingRedemptions;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.activeShares = relationships.activeShares;
    this.advocateEligibility = relationships.advocateEligibility;
    this.completedReferrals = relationships.completedReferrals;
  };

  return AdvocateProgramStatus;
}(Base$1);

AdvocateProgramStatus.type = 'advocateProgramStatus';
AdvocateProgramStatus.collectionPath = '/advocateProgramStatuses';
AdvocateProgramStatus = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], AdvocateProgramStatus);
var AdvocateProgramStatus$1 = AdvocateProgramStatus;
Factory.register(AdvocateProgramStatus.type, AdvocateProgramStatus);

var AggregateUserType = /*#__PURE__*/function (_Base) {
  _inheritsLoose(AggregateUserType, _Base);

  function AggregateUserType() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = AggregateUserType.prototype;

  ////////////////////
  //                //
  //   attributes   //
  //                //
  ////////////////////
  _proto.assignAttributes = function assignAttributes(_attributes) {// noop
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return AggregateUserType;
}(Base$1);

AggregateUserType.type = 'aggregateUserType';
AggregateUserType.collectionPath = '/aggregateUserTypes';
AggregateUserType = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], AggregateUserType);
var AggregateUserType$1 = AggregateUserType;
Factory.register(AggregateUserType.type, AggregateUserType);

var AnonymousCheckout = /*#__PURE__*/function (_Base) {
  _inheritsLoose(AnonymousCheckout, _Base);

  function AnonymousCheckout() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = AnonymousCheckout.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.additionalEligibleForCheckoutItems = attributes.additionalEligibleForCheckoutItems;
    this.anonymousUserReference = attributes.anonymousUserReference;
    this.bagItems = attributes.bagItems;
    this.charges = attributes.charges;
    this.checkoutId = attributes.checkoutId;
    this.checkoutStatus = attributes.checkoutStatus;
    this.expectedPayments = attributes.expectedPayments;
    this.membershipTierId = attributes.membershipTierId;
    this.partialAddress = attributes.partialAddress;
    this.passivePromoError = attributes.passivePromoError;
    this.paymentMethodIds = attributes.paymentMethodIds;
    this.paymentMethods = attributes.paymentMethods;
    this.promoCode = attributes.promoCode;
    this.shippingAddress = attributes.shippingAddress;
    this.shippingPostalCode = attributes.shippingPostalCode;
    this.type = attributes.type;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return AnonymousCheckout;
}(Base$1);

AnonymousCheckout.type = 'anonymousCheckout';
AnonymousCheckout.collectionPath = '/anonymousCheckouts';
AnonymousCheckout = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], AnonymousCheckout);
var AnonymousCheckout$1 = AnonymousCheckout;
Factory.register(AnonymousCheckout.type, AnonymousCheckout);

var AttributionSurvey = /*#__PURE__*/function (_Base) {
  _inheritsLoose(AttributionSurvey, _Base);

  function AttributionSurvey() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = AttributionSurvey.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.answer1 = attributes.answer1;
    this.answer2 = attributes.answer2;
    this.browserId = attributes.browserId;
    this.created = attributes.created;
    this.orderId = attributes.orderId;
    this.question1 = attributes.question1;
    this.question2 = attributes.question2;
    this.userId = attributes.userId;
    this.version = attributes.version;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return AttributionSurvey;
}(Base$1);

AttributionSurvey.type = 'attributionSurvey';
AttributionSurvey.collectionPath = '/attributionSurveys';
AttributionSurvey = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], AttributionSurvey);
var AttributionSurvey$1 = AttributionSurvey;
Factory.register(AttributionSurvey.type, AttributionSurvey);

var Authentication = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Authentication, _Base);

  function Authentication() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Authentication.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.action = attributes.action;
    this.digest = attributes.digest;
    this.timestamp = attributes.timestamp;
    this.currentSecret = attributes.currentSecret;
    this.email = attributes.email;
    this.provider = attributes.provider;
    this.secret = attributes.secret;
    this.source = attributes.source;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.token = relationships.token;
    this.user = relationships.user;
  };

  return Authentication;
}(Base$1);

Authentication.type = 'authentication';
Authentication.collectionPath = '/authentications';
Authentication = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Authentication);
var Authentication$1 = Authentication;
Factory.register(Authentication.type, Authentication);

var AuthenticationAttempt = /*#__PURE__*/function (_Base) {
  _inheritsLoose(AuthenticationAttempt, _Base);

  function AuthenticationAttempt() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = AuthenticationAttempt.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.action = attributes.action;
    this.challengeResponse = attributes.challengeResponse;
    this.email = attributes.email;
    this.provider = attributes.provider;
    this.secret = attributes.secret;
    this.source = attributes.source;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.token = relationships.token;
    this.user = relationships.user;
  };

  return AuthenticationAttempt;
}(Base$1);

AuthenticationAttempt.type = 'authenticationAttempt';
AuthenticationAttempt.collectionPath = '/authenticationAttempts';
AuthenticationAttempt = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], AuthenticationAttempt);
var AuthenticationAttempt$1 = AuthenticationAttempt;
Factory.register(AuthenticationAttempt.type, AuthenticationAttempt);

var AvailableStartDate = /*#__PURE__*/function (_Base) {
  _inheritsLoose(AvailableStartDate, _Base);

  function AvailableStartDate() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = AvailableStartDate.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.availableDate = attributes.availableDate;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return AvailableStartDate;
}(Base$1);

AvailableStartDate.type = 'availableStartDate';
AvailableStartDate.collectionPath = '/availableStartDates';
AvailableStartDate = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], AvailableStartDate);
var AvailableStartDate$1 = AvailableStartDate;
Factory.register(AvailableStartDate.type, AvailableStartDate);

var Award = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Award, _Base);

  function Award() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Award.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.expirationDate = attributes.expirationDate;
    this.participantId = attributes.participantId;
    this.promoCode = attributes.promoCode;
    this.referralId = attributes.referralId;
    this.rewardId = attributes.rewardId;
    this.rewardType = attributes.rewardType;
    this.state = attributes.state;
    this.subType = attributes.subType;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.participant = relationships.participant;
  };

  return Award;
}(Base$1);

Award.type = 'award';
Award.collectionPath = '/awards';
Award = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Award);
var Award$1 = Award;
Factory.register(Award.type, Award);

var Bag = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Bag, _Base);

  function Bag() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Bag.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.preTaxTotal = attributes.preTaxTotal;
    this.subTotal = attributes.subTotal;
    this.total = attributes.total;
    this.totalDiscount = attributes.totalDiscount;
    this.totalInsurance = attributes.totalInsurance;
    this.totalShipping = attributes.totalShipping;
    this.totalShippingDiscount = attributes.totalShippingDiscount;
    this.totalShippingMembershipDiscount = attributes.totalShippingMembershipDiscount;
    this.totalShippingPromoDiscount = attributes.totalShippingPromoDiscount;
    this.totalTax = attributes.totalTax;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.bagGroups = relationships.bagGroups;
    this.reservations = relationships.reservations;
  };

  return Bag;
}(Base$1);

Bag.type = 'bag';
Bag.collectionPath = '/bags';
Bag = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Bag);
var Bag$1 = Bag;
Factory.register(Bag.type, Bag);

var BagGroup = /*#__PURE__*/function (_Base) {
  _inheritsLoose(BagGroup, _Base);

  function BagGroup() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = BagGroup.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.date = attributes.date;
    this.duration = attributes.duration;
    this.insurance = attributes.insurance;
    this.preTaxTotal = attributes.preTaxTotal;
    this.salesTaxRate = attributes.salesTaxRate;
    this.shipping = attributes.shipping;
    this.shippingMembershipDiscount = attributes.shippingMembershipDiscount;
    this.shippingPromoDiscount = attributes.shippingPromoDiscount;
    this.subTotal = attributes.subTotal;
    this.tax = attributes.tax;
    this.total = attributes.total;
    this.totalDiscount = attributes.totalDiscount;
    this.totalShippingDiscount = attributes.totalShippingDiscount;
    this.useTaxRate = attributes.useTaxRate;
    this.zipCode = attributes.zipCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.reservations = relationships.reservations;
  };

  return BagGroup;
}(Base$1);

BagGroup.type = 'bagGroup';
BagGroup.collectionPath = '/bagGroups';
BagGroup = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], BagGroup);
var BagGroup$1 = BagGroup;
Factory.register(BagGroup.type, BagGroup);

var BagItemType;

(function (BagItemType) {
  BagItemType["ElectiveSaleBagItem"] = "ElectiveSaleBagItem";
  BagItemType["MembersBagItem"] = "MembersBagItem";
  BagItemType["ReserveBagItem"] = "ReserveBagItem";
  BagItemType["SubscriptionBagItem"] = "SubscriptionBagItem";
})(BagItemType || (BagItemType = {}));

var BagItem = /*#__PURE__*/function (_Base) {
  _inheritsLoose(BagItem, _Base);

  function BagItem() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = BagItem.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.beginDate = attributes.beginDate;
    this.bookingId = attributes.bookingId;
    this.createdAt = attributes.createdAt;
    this.designerName = attributes.designerName;
    this.displayName = attributes.displayName;
    this.holdId = attributes.holdId;
    this.images = attributes.images;
    this.membershipTierId = attributes.membershipTierId;
    this.pricing = attributes.pricing;
    this.size = attributes.size;
    this.sku = attributes.sku;
    this.type = attributes.type;
    this.zipCode = attributes.zipCode;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return BagItem;
}(Base$1);

BagItem.type = 'bagItem';
BagItem.collectionPath = '/bagItems';
BagItem = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], BagItem);
var BagItem$1 = BagItem;
Factory.register(BagItem.type, BagItem);

var BlackoutDay = /*#__PURE__*/function (_Base) {
  _inheritsLoose(BlackoutDay, _Base);

  function BlackoutDay() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = BlackoutDay.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.reason = attributes.reason;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return BlackoutDay;
}(Base$1);

BlackoutDay.type = 'blackoutDay';
BlackoutDay.collectionPath = '/blackoutDays';
BlackoutDay = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], BlackoutDay);
var BlackoutDay$1 = BlackoutDay;
Factory.register(BlackoutDay.type, BlackoutDay);

var Booking = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Booking, _Base);

  function Booking() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Booking.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.category = attributes.category;
    this.lastPossibleBeginDate = attributes.lastPossibleBeginDate;
    this.orderId = attributes.orderId;
    this.rentBegin = attributes.rentBegin;
    this.rentEnd = attributes.rentEnd;
    this.status = attributes.status;
    this.styleName = attributes.styleName;
    this.type = attributes.type;
    this.zipCode = attributes.zipCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.address = relationships.address;
    this.products = relationships.products;
    this.sku = relationships.sku;
    this.user = relationships.user;
  };

  return Booking;
}(Base$1);

Booking.type = 'booking';
Booking.collectionPath = '/bookings';
Booking = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Booking);
var Booking$1 = Booking;
Factory.register(Booking.type, Booking);

var BulkAvailability = /*#__PURE__*/function (_Base) {
  _inheritsLoose(BulkAvailability, _Base);

  function BulkAvailability() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = BulkAvailability.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.count = attributes.count;
    this.dateStart = attributes.dateStart;
    this.zipCode = attributes.zipCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.sku = relationships.sku;
  };

  return BulkAvailability;
}(Base$1);

BulkAvailability.type = 'bulkAvailability';
BulkAvailability.collectionPath = '/bulkAvailabilities';
BulkAvailability = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], BulkAvailability);
var BulkAvailability$1 = BulkAvailability;
Factory.register(BulkAvailability.type, BulkAvailability);

var Carousel = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Carousel, _Base);

  function Carousel() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Carousel.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.carouselType = attributes.carouselType;
    this.name = attributes.name;
    this.requestId = attributes.requestId;
    this.styleNames = attributes.styleNames;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.products = relationships.products;
    this.skus = relationships.skus;
  };

  return Carousel;
}(Base$1);

Carousel.type = 'carousel';
Carousel.collectionPath = '/carousels';
Carousel = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Carousel);
var Carousel$1 = Carousel;
Factory.register(Carousel.type, Carousel);

var CarouselInteraction = /*#__PURE__*/function (_Base) {
  _inheritsLoose(CarouselInteraction, _Base);

  function CarouselInteraction() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = CarouselInteraction.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.interaction = attributes.interaction;
    this.pdpStyleName = attributes.pdpStyleName;
    this.userId = attributes.userId;
    this.pdpCarouselName = attributes.pdpCarouselName;
  };

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return CarouselInteraction;
}(Base$1);

CarouselInteraction.type = 'carouselInteraction';
CarouselInteraction.collectionPath = '/carouselInteractions';
CarouselInteraction = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], CarouselInteraction);
var CarouselInteraction$1 = CarouselInteraction;
Factory.register(CarouselInteraction.type, CarouselInteraction);

var CheckoutType;

(function (CheckoutType) {
  CheckoutType["MEMBERS"] = "MEMBERS";
  CheckoutType["MIXED"] = "MIXED";
  CheckoutType["KIFAH"] = "KIFAH";
  CheckoutType["SUBSCRIPTION"] = "SUBSCRIPTION";
})(CheckoutType || (CheckoutType = {}));

var Checkout = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Checkout, _Base);

  function Checkout() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Checkout.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.bagItems = attributes.bagItems;
    this.charges = attributes.charges;
    this.checkoutId = attributes.checkoutId;
    this.checkoutStatus = attributes.checkoutStatus;
    this.checkoutType = attributes.checkoutType;
    this.expectedPayments = attributes.expectedPayments;
    this.partialAddress = attributes.partialAddress;
    this.passivePromoError = attributes.passivePromoError;
    this.paymentMethodIds = attributes.paymentMethodIds;
    this.paymentMethods = attributes.paymentMethods;
    this.promoCode = attributes.promoCode;
    this.shippingAddress = attributes.shippingAddress;
    this.shippingPostalCode = attributes.shippingPostalCode;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Checkout;
}(Base$1);

Checkout.type = 'checkout';
Checkout.collectionPath = '/checkouts';
Checkout = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Checkout);
var Checkout$1 = Checkout;
Factory.register(Checkout.type, Checkout);

var ClearanceAvailability = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ClearanceAvailability, _Base);

  function ClearanceAvailability() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ClearanceAvailability.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.count = attributes.count;
    this.date = attributes.date;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.sku = relationships.sku;
  };

  return ClearanceAvailability;
}(Base$1);

ClearanceAvailability.type = 'clearanceAvailability';
ClearanceAvailability.collectionPath = '/clearanceAvailabilities';
ClearanceAvailability = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ClearanceAvailability);
var ClearanceAvailability$1 = ClearanceAvailability;
Factory.register(ClearanceAvailability.type, ClearanceAvailability);

var CmsComponent = /*#__PURE__*/function (_Base) {
  _inheritsLoose(CmsComponent, _Base);

  function CmsComponent() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = CmsComponent.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.name = attributes.name;
    this.containerId = attributes.containerId;
    this.content = attributes.content;
    this.urlPatterns = attributes.urlPatterns;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {};

  return CmsComponent;
}(Base$1);

CmsComponent.type = 'cmsComponent';
CmsComponent.collectionPath = '/cmsComponents';
CmsComponent = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], CmsComponent);
var CmsComponent$1 = CmsComponent;
Factory.register(CmsComponent.type, CmsComponent);

var ComponentView = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ComponentView, _Base);

  function ComponentView() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ComponentView.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.userOrDeviceId = attributes.userOrDeviceId;
    this.contents = attributes.contents;
    this.content = attributes.content;
    this.urlPatterns = attributes.urlPatterns;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {};

  return ComponentView;
}(Base$1);

ComponentView.type = 'componentView';
ComponentView.collectionPath = '/componentViews';
ComponentView = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ComponentView);
var ComponentView$1 = ComponentView;
Factory.register(ComponentView.type, ComponentView);

var CrossShipReturnByDateForToday = /*#__PURE__*/function (_Base) {
  _inheritsLoose(CrossShipReturnByDateForToday, _Base);

  function CrossShipReturnByDateForToday() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = CrossShipReturnByDateForToday.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.date = attributes.date;
  };

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return CrossShipReturnByDateForToday;
}(Base$1);

CrossShipReturnByDateForToday.type = 'crossShipReturnByDateForToday';
CrossShipReturnByDateForToday.collectionPath = '/crossShipReturnByDateForToday';
CrossShipReturnByDateForToday = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], CrossShipReturnByDateForToday);
var CrossShipReturnByDateForToday$1 = CrossShipReturnByDateForToday;
Factory.register(CrossShipReturnByDateForToday.type, CrossShipReturnByDateForToday);

var Curation = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Curation, _Base);

  function Curation() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Curation.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.displayName = attributes.displayName;
    this.styleNames = attributes.styleNames;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Curation;
}(Base$1);

Curation.type = 'curation';
Curation.collectionPath = '/curations';
Curation = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Curation);
var Curation$1 = Curation;
Factory.register(Curation.type, Curation);

var CustomerChannelAttributionSurveyOption = /*#__PURE__*/function (_Base) {
  _inheritsLoose(CustomerChannelAttributionSurveyOption, _Base);

  function CustomerChannelAttributionSurveyOption() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = CustomerChannelAttributionSurveyOption.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.content = attributes.content;
  };

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return CustomerChannelAttributionSurveyOption;
}(Base$1);

CustomerChannelAttributionSurveyOption.type = 'customerChannelAttributionSurveyOption';
CustomerChannelAttributionSurveyOption.collectionPath = '/customerChannelAttributionSurveyOptions';
CustomerChannelAttributionSurveyOption = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], CustomerChannelAttributionSurveyOption);
var CustomerChannelAttributionSurveyOption$1 = CustomerChannelAttributionSurveyOption;
Factory.register(CustomerChannelAttributionSurveyOption.type, CustomerChannelAttributionSurveyOption);

var CustomerComment = /*#__PURE__*/function (_Base) {
  _inheritsLoose(CustomerComment, _Base);

  function CustomerComment() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = CustomerComment.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.agentName = attributes.agentName;
    this.comment = attributes.comment;
    this.datePosted = attributes.datePosted;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return CustomerComment;
}(Base$1);

CustomerComment.type = 'customerComment';
CustomerComment.collectionPath = '/customerComments';
CustomerComment = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], CustomerComment);
var CustomerComment$1 = CustomerComment;
Factory.register(CustomerComment.type, CustomerComment);

var CustomerPromiseItemSwapAction = /*#__PURE__*/function (_Base) {
  _inheritsLoose(CustomerPromiseItemSwapAction, _Base);

  function CustomerPromiseItemSwapAction() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = CustomerPromiseItemSwapAction.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.bookingIds = attributes.bookingIds;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return CustomerPromiseItemSwapAction;
}(Base$1);

CustomerPromiseItemSwapAction.type = 'membershipCustomerPromiseSwap';
CustomerPromiseItemSwapAction.collectionPath = '/membershipCustomerPromiseSwap';
CustomerPromiseItemSwapAction = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], CustomerPromiseItemSwapAction);
var CustomerPromiseItemSwapAction$1 = CustomerPromiseItemSwapAction;
Factory.register(CustomerPromiseItemSwapAction.type, CustomerPromiseItemSwapAction);

var Designer = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Designer, _Base);

  function Designer() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Designer.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.displayName = attributes.displayName;
    this.published = attributes.published;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Designer;
}(Base$1);

Designer.type = 'designer';
Designer.collectionPath = '/designers';
Designer = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Designer);
var Designer$1 = Designer;
Factory.register(Designer.type, Designer);

var DismissableModal = /*#__PURE__*/function (_Base) {
  _inheritsLoose(DismissableModal, _Base);

  function DismissableModal() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = DismissableModal.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.modalStatuses = attributes.modalStatuses;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
  };

  return DismissableModal;
}(Base$1);

DismissableModal.type = 'dismissableModal';
DismissableModal.collectionPath = '/dismissableModals';
DismissableModal = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], DismissableModal);
var DismissableModal$1 = DismissableModal;
Factory.register(DismissableModal.type, DismissableModal);

var EventSelection = /*#__PURE__*/function (_Base) {
  _inheritsLoose(EventSelection, _Base);

  function EventSelection() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = EventSelection.prototype;

  ////////////////////
  //                //
  //   attributes   //
  //                //
  ////////////////////
  _proto.assignAttributes = function assignAttributes(_attributes) {// noop
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.eventType = relationships.eventType;
  };

  return EventSelection;
}(Base$1);

EventSelection.type = 'eventSelection';
EventSelection.collectionPath = '/eventSelections';
EventSelection = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], EventSelection);
var EventSelection$1 = EventSelection;
Factory.register(EventSelection.type, EventSelection);

var EventType = /*#__PURE__*/function (_Base) {
  _inheritsLoose(EventType, _Base);

  function EventType() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = EventType.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.displayName = attributes.displayName;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.productRecos = relationships.productRecos;
  };

  return EventType;
}(Base$1);

EventType.type = 'eventType';
EventType.collectionPath = '/eventTypes';
EventType = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], EventType);
var EventType$1 = EventType;
Factory.register(EventType.type, EventType);

var Experiment = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Experiment, _Base);

  function Experiment() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Experiment.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.userId = attributes.userId;
    this.treatmentName = attributes.treatmentName;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.user = relationships.user;
  };

  return Experiment;
}(Base$1);

Experiment.type = 'experiment';
Experiment.collectionPath = '/experiments';
Experiment = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Experiment);
var Experiment$1 = Experiment;
Factory.register(Experiment.type, Experiment);

var ExpressCheckout = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ExpressCheckout, _Base);

  function ExpressCheckout() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ExpressCheckout.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.additionalEligibleForCheckoutItems = attributes.additionalEligibleForCheckoutItems;
    this.anonymousUserReference = attributes.anonymousUserReference;
    this.bagItems = attributes.bagItems;
    this.charges = attributes.charges;
    this.checkoutId = attributes.checkoutId;
    this.checkoutStatus = attributes.checkoutStatus;
    this.expectedPayments = attributes.expectedPayments;
    this.membershipTierId = attributes.membershipTierId;
    this.partialAddress = attributes.partialAddress;
    this.passivePromoError = attributes.passivePromoError;
    this.paymentMethodIds = attributes.paymentMethodIds;
    this.paymentMethods = attributes.paymentMethods;
    this.promoCode = attributes.promoCode;
    this.shippingAddress = attributes.shippingAddress;
    this.shippingPostalCode = attributes.shippingPostalCode;
    this.type = attributes.type;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return ExpressCheckout;
}(Base$1);

ExpressCheckout.type = 'expressCheckout';
ExpressCheckout.collectionPath = '/expressCheckouts';
ExpressCheckout = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ExpressCheckout);
var ExpressCheckout$1 = ExpressCheckout;
Factory.register(ExpressCheckout.type, ExpressCheckout);

var Flag = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Flag, _Base);

  function Flag() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Flag.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.type = attributes.type;
    this.value = attributes.value;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Flag;
}(Base$1);

Flag.type = 'flag';
Flag.collectionPath = '/flags';
Flag = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Flag);
var Flag$1 = Flag;
Factory.register(Flag.type, Flag);

var FuzzyGiraffeAvailability = /*#__PURE__*/function (_Base) {
  _inheritsLoose(FuzzyGiraffeAvailability, _Base);

  function FuzzyGiraffeAvailability() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = FuzzyGiraffeAvailability.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.count = attributes.count;
    this.readyToShipCount = attributes.readyToShipCount;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.sku = relationships.sku;
  };

  return FuzzyGiraffeAvailability;
}(Base$1);

FuzzyGiraffeAvailability.type = 'fuzzyGiraffeAvailability';
FuzzyGiraffeAvailability.collectionPath = '/fuzzyGiraffeAvailabilities';
FuzzyGiraffeAvailability = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], FuzzyGiraffeAvailability);
var FuzzyGiraffeAvailability$1 = FuzzyGiraffeAvailability;
Factory.register(FuzzyGiraffeAvailability.type, FuzzyGiraffeAvailability);

var GiftCard = /*#__PURE__*/function (_Base) {
  _inheritsLoose(GiftCard, _Base);

  function GiftCard() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = GiftCard.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.cardType = attributes.cardType;
    this.emailDate = attributes.emailDate;
    this.giftCardTransactions = attributes.giftCardTransactions;
    this.message = attributes.message;
    this.recipientEmail = attributes.recipientEmail;
    this.recipientName = attributes.recipientName;
    this.remainingBalance = attributes.remainingBalance;
    this.senderName = attributes.senderName;
    this.sku = attributes.sku;
    this.type = attributes.type;
    this.userId = attributes.userId;
    this.zipCode = attributes.zipCode;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return GiftCard;
}(Base$1);

GiftCard.type = 'giftCard';
GiftCard.collectionPath = '/giftCards';
GiftCard = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], GiftCard);
var GiftCard$1 = GiftCard;
Factory.register(GiftCard.type, GiftCard);

var GiftCardVerificationMethod = /*#__PURE__*/function (_Base) {
  _inheritsLoose(GiftCardVerificationMethod, _Base);

  function GiftCardVerificationMethod() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = GiftCardVerificationMethod.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.verificationMethod = attributes.verificationMethod;
    this.pinRequired = attributes.pinRequired;
    this.cvvRequired = attributes.cvvRequired;
    this.expiryDateRequired = attributes.expiryDateRequired;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return GiftCardVerificationMethod;
}(Base$1);

GiftCardVerificationMethod.type = 'giftCardVerificationMethod';
GiftCardVerificationMethod.collectionPath = '/giftCardVerificationMethods';
GiftCardVerificationMethod = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], GiftCardVerificationMethod);
var GiftCardVerificationMethod$1 = GiftCardVerificationMethod;
Factory.register(GiftCardVerificationMethod.type, GiftCardVerificationMethod);

var GroupInvoice = /*#__PURE__*/function (_Base) {
  _inheritsLoose(GroupInvoice, _Base);

  function GroupInvoice() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = GroupInvoice.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.charges = attributes.charges;
    this.totals = attributes.totals;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.lineItems = relationships.lineItems;
    this.orderGroup = relationships.orderGroup;
  };

  return GroupInvoice;
}(Base$1);

GroupInvoice.type = 'groupInvoice';
GroupInvoice.collectionPath = '/groupInvoices';
GroupInvoice = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], GroupInvoice);
var GroupInvoice$1 = GroupInvoice;
Factory.register(GroupInvoice.type, GroupInvoice);

var HappinessSurvey = /*#__PURE__*/function (_Base) {
  _inheritsLoose(HappinessSurvey, _Base);

  function HappinessSurvey() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = HappinessSurvey.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.bookingId = attributes.bookingId;
    this.comment = attributes.comment;
    this.created = attributes.created;
    this.size = attributes.size;
    this.source = attributes.source;
    this.status = attributes.status;
    this.styleName = attributes.styleName;
    this.surveyFeedbacks = attributes.surveyFeedbacks;
    this.userId = attributes.userId;
    this.version = attributes.version;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.product = relationships.product;
  };

  return HappinessSurvey;
}(Base$1);

HappinessSurvey.type = 'happinessSurvey';
HappinessSurvey.collectionPath = '/happinessSurveys';
HappinessSurvey = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], HappinessSurvey);
var HappinessSurvey$1 = HappinessSurvey;
Factory.register(HappinessSurvey.type, HappinessSurvey);

var Heart = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Heart, _Base);

  function Heart() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Heart.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.addedAt = attributes.addedAt;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.product = relationships.product;
  };

  return Heart;
}(Base$1);

Heart.type = 'heart';
Heart.collectionPath = '/hearts';
Heart = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Heart);
var Heart$1 = Heart;
Factory.register(Heart.type, Heart);

var HomePickupPostalCode = /*#__PURE__*/function (_Base) {
  _inheritsLoose(HomePickupPostalCode, _Base);

  function HomePickupPostalCode() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = HomePickupPostalCode.prototype;

  ////////////////////
  //                //
  //   attributes   //
  //                //
  ////////////////////
  _proto.assignAttributes = function assignAttributes(_attributes) {// noop
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return HomePickupPostalCode;
}(Base$1);

HomePickupPostalCode.type = 'homePickupPostalCode';
HomePickupPostalCode.collectionPath = '/homePickupPostalCodes';
HomePickupPostalCode = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], HomePickupPostalCode);
var HomePickupPostalCode$1 = HomePickupPostalCode;
Factory.register(HomePickupPostalCode.type, HomePickupPostalCode);

var HomePickupPostalCodeGroup = /*#__PURE__*/function (_Base) {
  _inheritsLoose(HomePickupPostalCodeGroup, _Base);

  function HomePickupPostalCodeGroup() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = HomePickupPostalCodeGroup.prototype;

  ////////////////////
  //                //
  //   attributes   //
  //                //
  ////////////////////
  _proto.assignAttributes = function assignAttributes(_attributes) {
    if (!_attributes) return;
    this.postalCodes = _attributes.postalCodes;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return HomePickupPostalCodeGroup;
}(Base$1);

HomePickupPostalCodeGroup.type = 'homePickupPostalCodeGroup';
HomePickupPostalCodeGroup.collectionPath = '/homePickupPostalCodeGroups';
HomePickupPostalCodeGroup = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], HomePickupPostalCodeGroup);
var HomePickupPostalCodeGroup$1 = HomePickupPostalCodeGroup;
Factory.register(HomePickupPostalCodeGroup.type, HomePickupPostalCodeGroup);

var Invoice = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Invoice, _Base);

  function Invoice() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Invoice.prototype;

  ////////////////////
  //                //
  //   attributes   //
  //                //
  ////////////////////
  _proto.assignAttributes = function assignAttributes(_attributes) {// noop
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.groups = relationships.groups;
  };

  return Invoice;
}(Base$1);

Invoice.type = 'invoice';
Invoice.collectionPath = '/invoices';
Invoice = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Invoice);
var Invoice$1 = Invoice;
Factory.register(Invoice.type, Invoice);

var ItemPurchaseCharge = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ItemPurchaseCharge, _Base);

  function ItemPurchaseCharge() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ItemPurchaseCharge.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.purchaseItems = attributes.purchaseItems;
    this.purchasePrice = attributes.purchasePrice;
    this.purchasePriceWithTax = attributes.purchasePriceWithTax;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return ItemPurchaseCharge;
}(Base$1);

ItemPurchaseCharge.type = 'itemPurchaseCharge';
ItemPurchaseCharge.collectionPath = '/itemPurchaseCharges';
ItemPurchaseCharge = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ItemPurchaseCharge);
var ItemPurchaseCharge$1 = ItemPurchaseCharge;
Factory.register(ItemPurchaseCharge.type, ItemPurchaseCharge);

var ItemReturnPromiseCollection = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ItemReturnPromiseCollection, _Base);

  function ItemReturnPromiseCollection() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ItemReturnPromiseCollection.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.bookingIds = attributes.bookingIds;
    this.comment = attributes.comment;
    this.creationSource = attributes.creationSource;
    this.employeeUsername = attributes.employeeUsername;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.membershipState = relationships.membershipState;
  };

  return ItemReturnPromiseCollection;
}(Base$1);

ItemReturnPromiseCollection.type = 'itemReturnPromiseCollection';
ItemReturnPromiseCollection.collectionPath = '/itemReturnPromiseCollection';
ItemReturnPromiseCollection = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ItemReturnPromiseCollection);
var ItemReturnPromiseCollection$1 = ItemReturnPromiseCollection;
Factory.register(ItemReturnPromiseCollection.type, ItemReturnPromiseCollection);

var LimitedAccountCompletion = /*#__PURE__*/function (_Base) {
  _inheritsLoose(LimitedAccountCompletion, _Base);

  function LimitedAccountCompletion() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = LimitedAccountCompletion.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.email = attributes.email;
    this.errors = attributes.errors;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.token = relationships.token;
    this.user = relationships.user;
  };

  return LimitedAccountCompletion;
}(Base$1);

LimitedAccountCompletion.type = 'limitedAccountCompletion';
LimitedAccountCompletion.collectionPath = '/limitedAccountCompletions';
LimitedAccountCompletion = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], LimitedAccountCompletion);
var LimitedAccountCompletion$1 = LimitedAccountCompletion;
Factory.register(LimitedAccountCompletion.type, LimitedAccountCompletion);

var LineItemInvoice = /*#__PURE__*/function (_Base) {
  _inheritsLoose(LineItemInvoice, _Base);

  function LineItemInvoice() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = LineItemInvoice.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.charges = attributes.charges;
    this.merchandiseCategory = attributes.merchandiseCategory;
    this.totals = attributes.totals;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.orderItem = relationships.orderItem;
    this.sku = relationships.sku;
  };

  return LineItemInvoice;
}(Base$1);

LineItemInvoice.type = 'lineItemInvoice';
LineItemInvoice.collectionPath = '/lineItemInvoices';
LineItemInvoice = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], LineItemInvoice);
var LineItemInvoice$1 = LineItemInvoice;
Factory.register(LineItemInvoice.type, LineItemInvoice);

var LoyaltyAward = /*#__PURE__*/function (_Base) {
  _inheritsLoose(LoyaltyAward, _Base);

  function LoyaltyAward() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = LoyaltyAward.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.awardId = attributes.awardId;
    this.rewardType = attributes.rewardType;
    this.awardState = attributes.awardState;
    this.rewardId = attributes.rewardId;
    this.projectedGrantDate = attributes.projectedGrantDate;
    this.grantedOnDate = attributes.grantedOnDate;
    this.redeemedOnDate = attributes.redeemedOnDate;
    this.unlockedOnDate = attributes.unlockedOnDate;
    this.claimByDate = attributes.claimByDate;
    this.useByDate = attributes.useByDate;
    this.eligibleForEarlyRedeem = attributes.eligibleForEarlyRedeem;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return LoyaltyAward;
}(Base$1);

LoyaltyAward.type = 'loyaltyAward';
LoyaltyAward.collectionPath = '/loyaltyAwards';
LoyaltyAward = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], LoyaltyAward);
var LoyaltyAward$1 = LoyaltyAward;
Factory.register(LoyaltyAward.type, LoyaltyAward);

var Membership = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Membership, _Base);

  function Membership() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Membership.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.billingStatus = attributes.billingStatus;
    this.cancelDate = attributes.cancelDate;
    this.category = attributes.category;
    this.endDate = attributes.endDate;
    this.futureSkipTerms = attributes.futureSkipTerms;
    this.onRackRentBeginDate = attributes.onRackRentBeginDate;
    this.orderId = attributes.orderId;
    this.preferences = attributes.preferences;
    this.rentBeginDate = attributes.rentBeginDate;
    this.resumeDate = attributes.resumeDate;
    this.startDate = attributes.startDate;
    this.status = attributes.status;
    this.termNumber = attributes.termNumber;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.user = relationships.user;
  };

  return Membership;
}(Base$1);

Membership.type = 'membership';
Membership.collectionPath = '/memberships';
Membership = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Membership);
var Membership$1 = Membership;
Factory.register(Membership.type, Membership);

var MembershipAction = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipAction, _Base);

  function MembershipAction() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipAction.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.action = attributes.action;
    this.addedOn = attributes.addedOn;
    this.barcode = attributes.barcode;
    this.bookingId = attributes.bookingId;
    this.comment = attributes.comment;
    this.creationSource = attributes.creationSource;
    this.effectiveOn = attributes.effectiveOn;
    this.endsOn = attributes.endsOn;
    this.membershipId = attributes.membershipId;
    this.orderId = attributes.orderId;
    this.paidSlotCount = attributes.paidSlotCount;
    this.productId = attributes.productId;
    this.shipmentAddressId = attributes.shipmentAddressId;
    this.sku = attributes.sku;
    this.slotCount = attributes.slotCount;
    this.subscriptionDiscountCategory = attributes.subscriptionDiscountCategory;
    this.subscriptionDiscountReason = attributes.subscriptionDiscountReason;
    this.subscriptionModPlanCode = attributes.subscriptionModPlanCode;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.membershipState = relationships.membershipState;
  };

  return MembershipAction;
}(Base$1);

MembershipAction.type = 'membershipAction';
MembershipAction.collectionPath = '/membershipActions';
MembershipAction = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipAction);
var MembershipAction$1 = MembershipAction;
Factory.register(MembershipAction.type, MembershipAction);

var MembershipActionCollection = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipActionCollection, _Base);

  function MembershipActionCollection() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipActionCollection.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.membershipActions = attributes.membershipActions;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.address = relationships.address;
    this.membershipState = relationships.membershipState;
    this.products = relationships.products;
  };

  return MembershipActionCollection;
}(Base$1);

MembershipActionCollection.type = 'membershipActionCollection';
MembershipActionCollection.collectionPath = '/membershipActionCollections';
MembershipActionCollection = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipActionCollection);
var MembershipActionCollection$1 = MembershipActionCollection;
Factory.register(MembershipActionCollection.type, MembershipActionCollection);

var MembershipAnswer = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipAnswer, _Base);

  function MembershipAnswer() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipAnswer.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.answers = attributes.answers;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  // no relationships
  ;

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return; // no relationships
  };

  return MembershipAnswer;
}(Base$1);

MembershipAnswer.type = 'membershipAnswer';
MembershipAnswer.collectionPath = '/membershipAnswers';
MembershipAnswer = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipAnswer);
var MembershipAnswer$1 = MembershipAnswer;
Factory.register(MembershipAnswer.type, MembershipAnswer);

var MembershipBag = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipBag, _Base);

  function MembershipBag() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipBag.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.numShipmentsPerTerm = attributes.numShipmentsPerTerm;
    this.numShipmentsRemaining = attributes.numShipmentsRemaining;
    this.hasOrderHistory = attributes.hasOrderHistory;
    this.baseSlotCount = attributes.baseSlotCount;
    this.numOpenSlots = attributes.numOpenSlots;
    this.numUpgradesInBag = attributes.numUpgradesInBag;
    this.baseSlotUpgradePrice = attributes.baseSlotUpgradePrice;
    this.isInSwapFlow = attributes.isInSwapFlow;
    this.isBagFull = attributes.isBagFull;
    this.checkoutReady = attributes.checkoutReady;
    this.failedToRefreshItems = attributes.failedToRefreshItems;
    this.items = attributes.items;
    this.checkout = attributes.checkout;
    this.crossShipReturnByDateForToday = attributes.crossShipReturnByDateForToday;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipBag;
}(Base$1);

MembershipBag.type = 'membershipBag';
MembershipBag.collectionPath = '/membershipBags';
MembershipBag = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipBag);
var MembershipBag$1 = MembershipBag;
Factory.register(MembershipBag.type, MembershipBag);

var MembershipChangePlan = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipChangePlan, _Base);

  function MembershipChangePlan() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipChangePlan.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.comment = attributes.comment;
    this.creationSource = attributes.creationSource;
    this.effectiveOn = attributes.effectiveOn;
    this.employeeUsername = attributes.employeeUsername;
    this.futureTierId = attributes.futureTierId;
    this.promoCode = attributes.promoCode;
    this.slotCountDifference = attributes.slotCountDifference;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipChangePlan;
}(Base$1);

MembershipChangePlan.type = 'membershipChangePlan';
MembershipChangePlan.collectionPath = '/membershipChangePlan';
MembershipChangePlan = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipChangePlan);
var MembershipChangePlan$1 = MembershipChangePlan;
Factory.register(MembershipChangePlan.type, MembershipChangePlan);

var MembershipChangeTierCharge = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipChangeTierCharge, _Base);

  function MembershipChangeTierCharge() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipChangeTierCharge.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.charges = attributes.charges;
    this.orderId = attributes.orderId;
    this.sequence = attributes.sequence;
    this.totals = attributes.totals;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.groups = relationships.groups;
  };

  return MembershipChangeTierCharge;
}(Base$1);

MembershipChangeTierCharge.type = 'membershipTierChangeCharge';
MembershipChangeTierCharge.collectionPath = '/membershipTierChangeCharges';
MembershipChangeTierCharge = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipChangeTierCharge);
var MembershipChangeTierCharge$1 = MembershipChangeTierCharge;
Factory.register(MembershipChangeTierCharge.type, MembershipChangeTierCharge);

var MembershipChangeTierPaymentOrderRequest = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipChangeTierPaymentOrderRequest, _Base);

  function MembershipChangeTierPaymentOrderRequest() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipChangeTierPaymentOrderRequest.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.membershipTierId = attributes.membershipTierId;
    this.orderSource = attributes.orderSource;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipChangeTierPaymentOrderRequest;
}(Base$1);

MembershipChangeTierPaymentOrderRequest.type = 'membershipTierChangePaymentOrder';
MembershipChangeTierPaymentOrderRequest.collectionPath = '/membershipTierChangePaymentOrders';
MembershipChangeTierPaymentOrderRequest = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipChangeTierPaymentOrderRequest);
var MembershipChangeTierPaymentOrderRequest$1 = MembershipChangeTierPaymentOrderRequest;
Factory.register(MembershipChangeTierPaymentOrderRequest.type, MembershipChangeTierPaymentOrderRequest);

var MembershipChangeTierRequest = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipChangeTierRequest, _Base);

  function MembershipChangeTierRequest() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipChangeTierRequest.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.creationSource = attributes.creationSource;
    this.effectiveOn = attributes.effectiveOn;
    this.employeeUsername = attributes.employeeUsername;
    this.endsOn = attributes.endsOn;
    this.futureTierId = attributes.futureTierId;
    this.resumingTierId = attributes.resumingTierId;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipChangeTierRequest;
}(Base$1);

MembershipChangeTierRequest.type = 'membershipChangeTier';
MembershipChangeTierRequest.collectionPath = '/membershipChangeTier';
MembershipChangeTierRequest = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipChangeTierRequest);
var MembershipChangeTierRequest$1 = MembershipChangeTierRequest;
Factory.register(MembershipChangeTierRequest.type, MembershipChangeTierRequest);

var MembershipCharge = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipCharge, _Base);

  function MembershipCharge() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipCharge.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.membershipChargeAmount = attributes.membershipChargeAmount;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipCharge;
}(Base$1);

MembershipCharge.type = 'membershipCharge';
MembershipCharge.collectionPath = '/membershipCharges';
MembershipCharge = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipCharge);
var MembershipCharge$1 = MembershipCharge;
Factory.register(MembershipCharge.type, MembershipCharge);

var MembershipEligibleForImmediateUpgrades = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipEligibleForImmediateUpgrades, _Base);

  function MembershipEligibleForImmediateUpgrades() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipEligibleForImmediateUpgrades.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.eligible = attributes.eligible;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipEligibleForImmediateUpgrades;
}(Base$1);

MembershipEligibleForImmediateUpgrades.type = 'membershipEligibleForImmediateUpgrades';
MembershipEligibleForImmediateUpgrades.collectionPath = '/membershipEligibleForImmediateUpgrades';
MembershipEligibleForImmediateUpgrades = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipEligibleForImmediateUpgrades);
var MembershipEligibleForImmediateUpgrades$1 = MembershipEligibleForImmediateUpgrades;
Factory.register(MembershipEligibleForImmediateUpgrades.type, MembershipEligibleForImmediateUpgrades);

var MembershipItemKept = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipItemKept, _Base);

  function MembershipItemKept() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipItemKept.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.bookingId = attributes.bookingId;
    this.comment = attributes.comment;
    this.creationSource = attributes.creationSource;
    this.employeeUsername = attributes.employeeUsername;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.membershipState = relationships.membershipState;
  };

  return MembershipItemKept;
}(Base$1);

MembershipItemKept.type = 'membershipItemKept';
MembershipItemKept.collectionPath = '/membershipItemKept';
MembershipItemKept = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipItemKept);
var MembershipItemKept$1 = MembershipItemKept;
Factory.register(MembershipItemKept.type, MembershipItemKept);

var MembershipPaymentOrder = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipPaymentOrder, _Base);

  function MembershipPaymentOrder() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipPaymentOrder.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.orderSource = attributes.orderSource;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipPaymentOrder;
}(Base$1);

MembershipPaymentOrder.type = 'membershipPaymentOrder';
MembershipPaymentOrder.collectionPath = '/membershipPaymentOrders';
MembershipPaymentOrder = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipPaymentOrder);
var MembershipPaymentOrder$1 = MembershipPaymentOrder;
Factory.register(MembershipPaymentOrder.type, MembershipPaymentOrder);

var MembershipRentalBegin = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipRentalBegin, _Base);

  function MembershipRentalBegin() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipRentalBegin.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.onRackRentBegin = attributes.onRackRentBegin;
    this.rentBegin = attributes.rentBegin;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipRentalBegin;
}(Base$1);

MembershipRentalBegin.type = 'membershipRentalBegin';
MembershipRentalBegin.collectionPath = '/membershipRentalBegins';
MembershipRentalBegin = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipRentalBegin);
var MembershipRentalBegin$1 = MembershipRentalBegin;
Factory.register(MembershipRentalBegin.type, MembershipRentalBegin);

var MembershipState = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipState, _Base);

  function MembershipState() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipState.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.membershipId = attributes.membershipId;
    this.membershipType = attributes.membershipType;
    this.membershipStatus = attributes.membershipStatus;
    this.billingStatus = attributes.billingStatus;
    this.shipmentAction = attributes.shipmentAction;
    this.membershipStartedOn = attributes.membershipStartedOn;
    this.membershipPausedOn = attributes.membershipPausedOn;
    this.membershipResumedOn = attributes.membershipResumedOn;
    this.membershipEndedOn = attributes.membershipEndedOn;
    this.nextBillingDate = attributes.nextBillingDate;
    this.billDayOfMonth = attributes.billDayOfMonth;
    this.termStart = attributes.termStart;
    this.termEnd = attributes.termEnd;
    this.eligiblePickDate = attributes.eligiblePickDate;
    this.shipmentAddressId = attributes.shipmentAddressId;
    this.shipmentPostalCode = attributes.shipmentPostalCode;
    this.membershipTermNumber = attributes.membershipTermNumber;
    this.programTermNumber = attributes.programTermNumber;
    this.gracePeriodLength = attributes.gracePeriodLength;
    this.eligibleAddonItems = attributes.eligibleAddonItems;
    this.minimumItems = attributes.minimumItems;
    this.addonItemPrice = attributes.addonItemPrice;
    this.baseSlotUpgradePrice = attributes.baseSlotUpgradePrice;
    this.recurringPrice = attributes.recurringPrice;
    this.futureBaseSlotCount = attributes.futureBaseSlotCount;
    this.futureBaseSlotCounts = attributes.futureBaseSlotCounts;
    this.paidSlotCountOnNextBillingDate = attributes.paidSlotCountOnNextBillingDate;
    this.swapForFitPrice = attributes.swapForFitPrice;
    this.lateFee = attributes.lateFee;
    this.onboarded = attributes.onboarded;
    this.shipmentsCount = attributes.shipmentsCount;
    this.shipmentIds = attributes.shipmentIds;
    this.crossShipEligible = attributes.crossShipEligible;
    this.hasOrderHistory = attributes.hasOrderHistory;
    this.baseSlotCount = attributes.baseSlotCount;
    this.slotsFromReward = attributes.slotsFromReward;
    this.eligibleToPick = attributes.eligibleToPick;
    this.slots = attributes.slots;
    this.disabledSlots = attributes.disabledSlots;
    this.membershipItems = attributes.membershipItems;
    this.programHistory = attributes.programHistory;
    this.subscriptionDiscounts = attributes.subscriptionDiscounts;
    this.monthlyShipmentLimit = attributes.monthlyShipmentLimit;
    this.membershipTierName = attributes.membershipTierName;
    this.inventoryEligibilities = attributes.inventoryEligibilities;
    this.membershipTierRevisionId = attributes.membershipTierRevisionId;
    this.membershipTierId = attributes.membershipTierId;
    this.alwaysOnAddOnEligible = attributes.alwaysOnAddOnEligible;
    this.futureMembershipTierRevision = attributes.futureMembershipTierRevision;
    this.previousMembershipTierRevision = attributes.previousMembershipTierRevision;
    this.tierChangeStartedOn = attributes.tierChangeStartedOn;
    this.previousTierResumesOn = attributes.previousTierResumesOn;
    this.tierBaseSlotCount = attributes.tierBaseSlotCount;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.address = relationships.address;
    this.itemPurchaseCharge = relationships.itemPurchaseCharge;
    this.loyaltyAwards = relationships.loyaltyAwards;
    this.products = relationships.products;
    this.membershipRentalBegin = relationships.membershipRentalBegin;
    this.membershipEligibleForImmediateUpgrades = relationships.membershipEligibleForImmediateUpgrades;
  };

  return MembershipState;
}(Base$1);

MembershipState.type = 'membershipState';
MembershipState.collectionPath = '/membershipStates';
MembershipState = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipState);
var MembershipState$1 = MembershipState;
Factory.register(MembershipState.type, MembershipState);

var MembershipTier = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipTier, _Base);

  function MembershipTier() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipTier.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.basePrice = attributes.basePrice;
    this.baseSlotUpgradePrice = attributes.baseSlotUpgradePrice;
    this.createdAt = attributes.createdAt;
    this.enabledAt = attributes.enabledAt;
    this.disabledAt = attributes.disabledAt;
    this.inventoryEligibilities = attributes.inventoryEligibilities;
    this.membershipTierRevisionId = attributes.membershipTierRevisionId;
    this.monthlyShipmentLimit = attributes.monthlyShipmentLimit;
    this.name = attributes.name;
    this.slotCount = attributes.slotCount;
    this.updatedAt = attributes.updatedAt;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipTier;
}(Base$1);

MembershipTier.type = 'membershipTier';
MembershipTier.collectionPath = '/membershipTiers';
MembershipTier = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipTier);
var MembershipTier$1 = MembershipTier;
Factory.register(MembershipTier.type, MembershipTier);

var MembershipTierChangePreview = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipTierChangePreview, _Base);

  function MembershipTierChangePreview() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipTierChangePreview.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.membershipTierId = attributes.membershipTierId;
    this.membershipTierRevisionId = attributes.membershipTierRevisionId;
    this.promoCode = attributes.promoCode;
    this.recurringPrice = attributes.recurringPrice;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipTierChangePreview;
}(Base$1);

MembershipTierChangePreview.type = 'membershipTierChangePreview';
MembershipTierChangePreview.collectionPath = '/membershipTierChangePreview';
MembershipTierChangePreview = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipTierChangePreview);
var MembershipTierChangePreview$1 = MembershipTierChangePreview;
Factory.register(MembershipTierChangePreview.type, MembershipTierChangePreview);

var MembershipUndoChangeTierRequest = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MembershipUndoChangeTierRequest, _Base);

  function MembershipUndoChangeTierRequest() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MembershipUndoChangeTierRequest.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.comment = attributes.comment;
    this.creationSource = attributes.creationSource;
    this.employeeUsername = attributes.employeeUsername;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MembershipUndoChangeTierRequest;
}(Base$1);

MembershipUndoChangeTierRequest.type = 'membershipUndoChangeTier';
MembershipUndoChangeTierRequest.collectionPath = '/membershipUndoChangeTier';
MembershipUndoChangeTierRequest = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MembershipUndoChangeTierRequest);
var MembershipUndoChangeTierRequest$1 = MembershipUndoChangeTierRequest;
Factory.register(MembershipUndoChangeTierRequest.type, MembershipUndoChangeTierRequest);

var MomentReview = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MomentReview, _Base);

  function MomentReview() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MomentReview.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.item = attributes.item;
    this.user = attributes.user;
    this.moment = attributes.moment;
    this.mapOfStyleNamesToItems = attributes.mapOfStyleNamesToItems;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return MomentReview;
}(Base$1);

MomentReview.type = 'momentUnrestrictedReview';
MomentReview.collectionPath = '/momentUnrestrictedReviews';
MomentReview = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MomentReview);
var MomentReview$1 = MomentReview;
Factory.register(MomentReview.type, MomentReview);

var NotifyMe = /*#__PURE__*/function (_Base) {
  _inheritsLoose(NotifyMe, _Base);

  function NotifyMe() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = NotifyMe.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return; // the backend responds with `watchlistItems`
    // but we want to map it use `notifyMeItems` instead

    this.notifyMeItems = attributes.watchlistItems;
    this.notificationRules = attributes.notificationRules;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return NotifyMe;
}(Base$1);

NotifyMe.type = 'watchlist';
NotifyMe.collectionPath = '/watchlists';
NotifyMe = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], NotifyMe);
var NotifyMe$1 = NotifyMe;
Factory.register(NotifyMe.type, NotifyMe);

var OnboardingQuizResponse = /*#__PURE__*/function (_Base) {
  _inheritsLoose(OnboardingQuizResponse, _Base);

  function OnboardingQuizResponse() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = OnboardingQuizResponse.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.backupUsStandardSize = attributes.backupUsStandardSize;
    this.bride = attributes.bride;
    this.bridesmaid = attributes.bridesmaid;
    this.bridesmaidDate = attributes.bridesmaidDate;
    this.created = attributes.created;
    this.dealbreakerColors = attributes.dealbreakerColors;
    this.dealbreakerEmbellishments = attributes.dealbreakerEmbellishments;
    this.designers = attributes.designers;
    this.dueDate = attributes.dueDate;
    this.eventTypes = attributes.eventTypes;
    this.firstName = attributes.firstName;
    this.heightInches = attributes.heightInches;
    this.inMaternity = attributes.inMaternity;
    this.nightOutStyle = attributes.nightOutStyle;
    this.quizVersion = attributes.quizVersion;
    this.styles = attributes.styles;
    this.upcomingEvent = attributes.upcomingEvent;
    this.updated = attributes.updated;
    this.usStandardSize = attributes.usStandardSize;
    this.weddingDate = attributes.weddingDate;
    this.weekendStyle = attributes.weekendStyle;
    this.workFormalities = attributes.workFormalities;
    this.workdayStyle = attributes.workdayStyle;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.user = relationships.user;
  };

  return OnboardingQuizResponse;
}(Base$1);

OnboardingQuizResponse.type = 'onboardingQuizResponse';
OnboardingQuizResponse.collectionPath = '/onboardingQuizResponses';
OnboardingQuizResponse = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], OnboardingQuizResponse);
var OnboardingQuizResponse$1 = OnboardingQuizResponse;
Factory.register(OnboardingQuizResponse.type, OnboardingQuizResponse);

var OnboardingQuizResult = /*#__PURE__*/function (_Base) {
  _inheritsLoose(OnboardingQuizResult, _Base);

  function OnboardingQuizResult() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = OnboardingQuizResult.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.name = attributes.name;
    this.requestId = attributes.requestId;
    this.styleNames = attributes.styleNames;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.products = relationships.products;
    this.skus = relationships.skus;
  };

  return OnboardingQuizResult;
}(Base$1);

OnboardingQuizResult.type = 'onboardingQuizResult';
OnboardingQuizResult.collectionPath = '/onboardingQuizResults';
OnboardingQuizResult = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], OnboardingQuizResult);
var OnboardingQuizResult$1 = OnboardingQuizResult;
Factory.register(OnboardingQuizResult.type, OnboardingQuizResult);

var Order = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Order, _Base);

  function Order() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Order.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.createdAt = attributes.createdAt;
    this.groups = attributes.groups;
    this.paymentMethodIds = attributes.paymentMethodIds;
    this.promoCode = attributes.promoCode;
    this.source = attributes.source;
    this.status = attributes.status;
    this.updatedAt = attributes.updatedAt;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.currentInvoice = relationships.currentInvoice;
    this.invoices = relationships.invoices;
    this.paymentMethods = relationships.paymentMethods;
    this.previewInvoice = relationships.previewInvoice;
    this.user = relationships.user;
  };

  return Order;
}(Base$1);

Order.type = 'order';
Order.collectionPath = '/orders';
Order = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Order);
var Order$1 = Order;
Factory.register(Order.type, Order);

var OrderConfirmationSummary = /*#__PURE__*/function (_Base) {
  _inheritsLoose(OrderConfirmationSummary, _Base);

  function OrderConfirmationSummary() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = OrderConfirmationSummary.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.billingInfo = attributes.billingInfo;
    this.containsMembershipProduct = attributes.containsMembershipProduct;
    this.email = attributes.email;
    this.groups = attributes.groups;
    this.isReturningCustomer = attributes.isReturningCustomer;
    this.orderId = attributes.orderId;
    this.orderSummary = attributes.orderSummary;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return OrderConfirmationSummary;
}(Base$1);

OrderConfirmationSummary.type = 'orderConfirmationSummary';
OrderConfirmationSummary.collectionPath = '/orderConfirmationSummaries';
OrderConfirmationSummary = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], OrderConfirmationSummary);
var OrderConfirmationSummary$1 = OrderConfirmationSummary;
Factory.register(OrderConfirmationSummary.type, OrderConfirmationSummary);

var OrderConversionData = /*#__PURE__*/function (_Base) {
  _inheritsLoose(OrderConversionData, _Base);

  function OrderConversionData() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = OrderConversionData.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.discountedSubtotal = attributes.discountedSubtotal;
    this.items = attributes.items;
    this.orderId = attributes.orderId;
    this.promo = attributes.promo;
    this.returningCustomer = attributes.returningCustomer;
    this.shipping = attributes.shipping;
    this.tax = attributes.tax;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return OrderConversionData;
}(Base$1);

OrderConversionData.type = 'orderConversionData';
OrderConversionData.collectionPath = '/orderConversionData';
OrderConversionData = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], OrderConversionData);
var OrderConversionData$1 = OrderConversionData;
Factory.register(OrderConversionData.type, OrderConversionData);

var OrderGroup = /*#__PURE__*/function (_Base) {
  _inheritsLoose(OrderGroup, _Base);

  function OrderGroup() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = OrderGroup.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.activeGroups = attributes.activeGroups;
    this.addressId = attributes.addressId;
    this.fulfillmentMethod = attributes.fulfillmentMethod;
    this.problemGroup = attributes.problemGroup;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.bookings = relationships.bookings;
  };

  return OrderGroup;
}(Base$1);

OrderGroup.type = 'orderGroup';
OrderGroup.collectionPath = '/orderGroups';
OrderGroup = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], OrderGroup);
var OrderGroup$1 = OrderGroup;
Factory.register(OrderGroup.type, OrderGroup);

var OrderInvoice = /*#__PURE__*/function (_Base) {
  _inheritsLoose(OrderInvoice, _Base);

  function OrderInvoice() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = OrderInvoice.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.charges = attributes.charges;
    this.orderId = attributes.orderId;
    this.sequence = attributes.sequence;
    this.totals = attributes.totals;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.groups = relationships.groups;
  };

  return OrderInvoice;
}(Base$1);

OrderInvoice.type = 'orderInvoice';
OrderInvoice.collectionPath = '/orderInvoices';
OrderInvoice = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], OrderInvoice);
var OrderInvoice$1 = OrderInvoice;
Factory.register(OrderInvoice.type, OrderInvoice);

var OrderItem = /*#__PURE__*/function (_Base) {
  _inheritsLoose(OrderItem, _Base);

  function OrderItem() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = OrderItem.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.backupForId = attributes.backupForId;
    this.bookingId = attributes.bookingId;
    this.cardType = attributes.cardType;
    this.createdAt = attributes.createdAt;
    this.emailDate = attributes.emailDate;
    this.membershipTierId = attributes.membershipTierId;
    this.message = attributes.message;
    this.orderType = attributes.orderType;
    this.recipientEmail = attributes.recipientEmail;
    this.recipientName = attributes.recipientName;
    this.rentBegin = attributes.rentBegin;
    this.rentEnd = attributes.rentEnd;
    this.senderName = attributes.senderName; // this is a known oddity of Godmother OrderItem models

    this.skuId = attributes.sku;
    this.subType = attributes.subType;
    this.updatedAt = attributes.updatedAt;
    this.userId = attributes.userId;
    this.zipCode = attributes.zipCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.sku = relationships.sku;
  };

  return OrderItem;
}(Base$1);

OrderItem.type = 'orderItem';
OrderItem.collectionPath = '/orderItems';
OrderItem = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], OrderItem);
var OrderItem$1 = OrderItem;
Factory.register(OrderItem.type, OrderItem);

var OrderTrackingData = /*#__PURE__*/function (_Base) {
  _inheritsLoose(OrderTrackingData, _Base);

  function OrderTrackingData() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = OrderTrackingData.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.depotId = attributes.depotId;
    this.orderGroupId = attributes.orderGroupId;
    this.outForDeliveryEvents = attributes.outForDeliveryEvents;
    this.shipDate = attributes.shipDate;
    this.shipmentEvents = attributes.shipmentEvents;
    this.skus = attributes.skus;
    this.trackingCodes = attributes.trackingCodes;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return OrderTrackingData;
}(Base$1);

OrderTrackingData.type = 'tracking';
OrderTrackingData.collectionPath = '/orderTrackingData';
OrderTrackingData = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], OrderTrackingData);
var OrderTrackingData$1 = OrderTrackingData;
Factory.register(OrderTrackingData.type, OrderTrackingData);

var Participant = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Participant, _Base);

  function Participant() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Participant.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.browserId = attributes.browserId;
    this.subType = attributes.subType;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.user = relationships.user;
  };

  return Participant;
}(Base$1);

Participant.type = 'participant';
Participant.collectionPath = '/participants';
Participant = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Participant);
var Participant$1 = Participant;
Factory.register(Participant.type, Participant);

var Partition = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Partition, _Base);

  function Partition() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Partition.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.childrenIds = attributes.childrenIds;
    this.displayName = attributes.displayName;
    this.parentId = attributes.parentId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Partition;
}(Base$1);

Partition.type = 'partition';
Partition.collectionPath = '/partitions';
Partition = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Partition);
var Partition$1 = Partition;
Factory.register(Partition.type, Partition);

var PasswordResetCompletion = /*#__PURE__*/function (_Base) {
  _inheritsLoose(PasswordResetCompletion, _Base);

  function PasswordResetCompletion() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = PasswordResetCompletion.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.digest = attributes.digest;
    this.newPassword = attributes.newPassword;
    this.timestamp = attributes.timestamp;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return PasswordResetCompletion;
}(Base$1);

PasswordResetCompletion.type = 'passwordResetCompletion';
PasswordResetCompletion.collectionPath = '/passwordResetCompletions';
PasswordResetCompletion = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], PasswordResetCompletion);
var PasswordResetCompletion$1 = PasswordResetCompletion;
Factory.register(PasswordResetCompletion.type, PasswordResetCompletion);

var PasswordResetInitiation = /*#__PURE__*/function (_Base) {
  _inheritsLoose(PasswordResetInitiation, _Base);

  function PasswordResetInitiation() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = PasswordResetInitiation.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.email = attributes.email;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return PasswordResetInitiation;
}(Base$1);

PasswordResetInitiation.type = 'passwordResetInitiation';
PasswordResetInitiation.collectionPath = '/passwordResetInitiations';
PasswordResetInitiation = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], PasswordResetInitiation);
var PasswordResetInitiation$1 = PasswordResetInitiation;
Factory.register(PasswordResetInitiation.type, PasswordResetInitiation);

var PaymentMethod = /*#__PURE__*/function (_Base) {
  _inheritsLoose(PaymentMethod, _Base);

  function PaymentMethod() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = PaymentMethod.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.active = attributes.active;
    this.balance = attributes.balance;
    this.cardNumber = attributes.cardNumber;
    this.cardType = attributes.cardType;
    this.city = attributes.city;
    this.code = attributes.code;
    this["default"] = attributes["default"];
    this.recurring = attributes.recurring;
    this.eProtectRegistrationId = attributes.eProtectRegistrationId;
    this.expiration = attributes.expiration;
    this.expired = attributes.expired;
    this.firstName = attributes.firstName;
    this.lastName = attributes.lastName;
    this.name = attributes.name;
    this.phone = attributes.phone;
    this.postalCode = attributes.postalCode;
    this.securityCode = attributes.securityCode;
    this.street1 = attributes.street1;
    this.street2 = attributes.street2;
    this.subType = attributes.subType;
    this.userId = attributes.userId;
    this.zoneCode = attributes.zoneCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.user = relationships.user;
  };

  return PaymentMethod;
}(Base$1);

PaymentMethod.type = 'paymentMethod';
PaymentMethod.collectionPath = '/paymentMethods';
PaymentMethod = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], PaymentMethod);
var PaymentMethod$1 = PaymentMethod;
Factory.register(PaymentMethod.type, PaymentMethod);

var Photo = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Photo, _Base);

  function Photo() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Photo.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.urls = attributes.urls;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Photo;
}(Base$1);

Photo.type = 'photo';
Photo.collectionPath = '/photos';
Photo = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Photo);
var Photo$1 = Photo;
Factory.register(Photo.type, Photo);

var OrderSourceType;

(function (OrderSourceType) {
  OrderSourceType["STOREFRONT"] = "STOREFRONT";
})(OrderSourceType || (OrderSourceType = {}));

var PlacedOrder = /*#__PURE__*/function (_Base) {
  _inheritsLoose(PlacedOrder, _Base);

  function PlacedOrder() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = PlacedOrder.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.checkoutId = attributes.checkoutId;
    this.context = attributes.context;
    this.orderId = attributes.orderId;
    this.orderSource = attributes.orderSource;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return PlacedOrder;
}(Base$1);

PlacedOrder.type = 'placedOrder';
PlacedOrder.collectionPath = '/placedOrders';
PlacedOrder = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], PlacedOrder);
var PlacedOrder$1 = PlacedOrder;
Factory.register(PlacedOrder.type, PlacedOrder);

var Price = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Price, _Base);

  function Price() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Price.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.adjusted = attributes.adjusted;
    this.adjustedMaximum = attributes.adjustedMaximum;
    this.adjustedMinimum = attributes.adjustedMinimum;
    this.base = attributes.base;
    this.date = attributes.date;
    this.discounts = attributes.discounts;
    this.duration = attributes.duration;
    this.maximum = attributes.maximum;
    this.merchandiseCategory = attributes.merchandiseCategory;
    this.minimum = attributes.minimum;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.product = relationships.product;
  };

  return Price;
}(Base$1);

Price.type = 'price';
Price.collectionPath = '/prices';
Price = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Price);
var Price$1 = Price;
Factory.register(Price.type, Price);

var Product = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Product, _Base);

  function Product() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Product.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.ageRanges = attributes.ageRanges;
    this.bodyTypes = attributes.bodyTypes;
    this.canonicalSizes = attributes.canonicalSizes;
    this.colors = attributes.colors;
    this.created = attributes.created;
    this.designer = attributes.designer;
    this.displayName = attributes.displayName;
    this.eligibleFor = attributes.eligibleFor;
    this.embellishments = attributes.embellishments;
    this.fitNotes = attributes.fitNotes;
    this.formality = attributes.formality;
    this.formalityScore = attributes.formalityScore;
    this.images = attributes.images;
    this.isAvailableForQueue = attributes.isAvailableForQueue;
    this.length = attributes.length;
    this.modified = attributes.modified;
    this.neckline = attributes.neckline;
    this.occasions = attributes.occasions;
    this.pdpCarouselList = attributes.pdpCarouselList;
    this.postingDate = attributes.postingDate;
    this.productDetails = attributes.productDetails;
    this.published = attributes.published;
    this.purchasePrice = attributes.purchasePrice;
    this.purchasePriceDiscountFromRetailPrice = attributes.purchasePriceDiscountFromRetailPrice;
    this.queueable = attributes.queueable;
    this.retailPrice = attributes.retailPrice;
    this.rtrCost = attributes.rtrCost;
    this.season = attributes.season;
    this.sizes = attributes.sizes;
    this.sleeve = attributes.sleeve;
    this.stylistNotes = attributes.stylistNotes;
    this.urlHistory = attributes.urlHistory;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.category = relationships.category;
    this.fitRates = relationships.fitRates;
    this.price = relationships.price;
    this.prices = relationships.prices;
    this.sizeScale = relationships.sizeScale;
    this.skus = relationships.skus;
  };

  return Product;
}(Base$1);

Product.type = 'product';
Product.collectionPath = '/products';
Product = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Product);
var Product$1 = Product;
Factory.register(Product.type, Product);

var ProductCategory = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ProductCategory, _Base);

  function ProductCategory() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ProductCategory.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.attributes = attributes.attributes;
    this.displayName = attributes.displayName;
    this.facets = attributes.facets;
    this.schema = attributes.schema;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.children = relationships.children;
    this.parent = relationships.parent;
  };

  return ProductCategory;
}(Base$1);

ProductCategory.type = 'productCategory';
ProductCategory.collectionPath = '/productCategories';
ProductCategory = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ProductCategory);
var ProductCategory$1 = ProductCategory;
Factory.register(ProductCategory.type, ProductCategory);

var ProductCollection = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ProductCollection, _Base);

  function ProductCollection() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ProductCollection.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.active = attributes.active;
    this.createdAt = attributes.createdAt;
    this.description = attributes.description;
    this.eventDate = attributes.eventDate;
    this.eventTypeId = attributes.eventTypeId;
    this.modifiedAt = attributes.modifiedAt;
    this.name = attributes.name;
    this.userId = attributes.userId;
    this.zipCode = attributes.zipCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.eventType = relationships.eventType;
    this.productCollectionMembers = relationships.productCollectionMembers;
    this.productCollectionRejectedMembers = relationships.productCollectionRejectedMembers;
    this.productRecos = relationships.productRecos;
    this.user = relationships.user;
  };

  return ProductCollection;
}(Base$1);

ProductCollection.type = 'productCollection';
ProductCollection.collectionPath = '/productCollections';
ProductCollection = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ProductCollection);
var ProductCollection$1 = ProductCollection;
Factory.register(ProductCollection.type, ProductCollection);

var ProductCollectionMember = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ProductCollectionMember, _Base);

  function ProductCollectionMember() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ProductCollectionMember.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.addedAt = attributes.addedAt;
    this.index = attributes.index;
    this.productCollectionId = attributes.productCollectionId;
    this.selectedSkus = attributes.selectedSkus;
    this.styleId = attributes.styleId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.product = relationships.product;
  };

  return ProductCollectionMember;
}(Base$1);

ProductCollectionMember.type = 'productCollectionMember';
ProductCollectionMember.collectionPath = '/productCollectionMembers';
ProductCollectionMember = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ProductCollectionMember);
var ProductCollectionMember$1 = ProductCollectionMember;
Factory.register(ProductCollectionMember.type, ProductCollectionMember);

var ProductCollectionRejectedMember = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ProductCollectionRejectedMember, _Base);

  function ProductCollectionRejectedMember() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ProductCollectionRejectedMember.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.productCollectionId = attributes.productCollectionId;
    this.styleId = attributes.styleId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.product = relationships.product;
  };

  return ProductCollectionRejectedMember;
}(Base$1);

ProductCollectionRejectedMember.type = 'productCollectionRejectedMember';
ProductCollectionRejectedMember.collectionPath = '/productCollectionRejectedMembers';
ProductCollectionRejectedMember = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ProductCollectionRejectedMember);
var ProductCollectionRejectedMember$1 = ProductCollectionRejectedMember;
Factory.register(ProductCollectionRejectedMember.type, ProductCollectionRejectedMember);

var ProductExtra = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ProductExtra, _Base);

  function ProductExtra() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ProductExtra.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.description = attributes.description;
    this.styleName = attributes.styleName;
    this.subType = attributes.subType;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return ProductExtra;
}(Base$1);

ProductExtra.type = 'productExtra';
ProductExtra.collectionPath = '/productExtras';
ProductExtra = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ProductExtra);
var ProductExtra$1 = ProductExtra;
Factory.register(ProductExtra.type, ProductExtra);

var ProductFitIssueRate = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ProductFitIssueRate, _Base);

  function ProductFitIssueRate() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ProductFitIssueRate.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.canonicalSize = attributes.canonicalSize;
    this.fitRate = attributes.fitRate;
    this.isRecommended = attributes.isRecommended;
    this.numResponses = attributes.numResponses;
    this.size = attributes.size;
    this.userSize = attributes.userSize;
    this.priority = attributes.priority;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return ProductFitIssueRate;
}(Base$1);

ProductFitIssueRate.type = 'productFitIssueRate';
ProductFitIssueRate.collectionPath = '/productFitIssueRate';
ProductFitIssueRate = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ProductFitIssueRate);
var ProductFitIssueRate$1 = ProductFitIssueRate;
Factory.register(ProductFitIssueRate.type, ProductFitIssueRate);

var ProductRatingSummary = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ProductRatingSummary, _Base);

  function ProductRatingSummary() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ProductRatingSummary.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.count = attributes.count;
    this.lastTwoImageSets = attributes.lastTwoImageSets;
    this.lastTwoStyles = attributes.lastTwoStyles;
    this.ratingAction = attributes.ratingAction;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.productCollections = relationships.productCollections;
  };

  return ProductRatingSummary;
}(Base$1);

ProductRatingSummary.type = 'productRatingSummary';
ProductRatingSummary.collectionPath = '/productRatingSummary';
ProductRatingSummary = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ProductRatingSummary);
var ProductRatingSummary$1 = ProductRatingSummary;
Factory.register(ProductRatingSummary.type, ProductRatingSummary);

var ProductReco = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ProductReco, _Base);

  function ProductReco() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ProductReco.prototype;

  ////////////////////
  //                //
  //   attributes   //
  //                //
  ////////////////////
  _proto.assignAttributes = function assignAttributes(_attributes) {// noop
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.product = relationships.product;
  };

  return ProductReco;
}(Base$1);

ProductReco.type = 'productReco';
ProductReco.collectionPath = '/productRecos';
ProductReco = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ProductReco);
var ProductReco$1 = ProductReco;
Factory.register(ProductReco.type, ProductReco);

var ProgramRule = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ProgramRule, _Base);

  function ProgramRule() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ProgramRule.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.advocateDaysToShare = attributes.advocateDaysToShare;
    this.advocateTermCount = attributes.advocateTermCount;
    this.daysToRedeem = attributes.daysToRedeem;
    this.endsAt = attributes.endsAt;
    this.programType = attributes.programType;
    this.ruleDescription = attributes.ruleDescription;
    this.startsAt = attributes.startsAt;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.rewards = relationships.rewards;
  };

  return ProgramRule;
}(Base$1);

ProgramRule.type = 'programRule';
ProgramRule.collectionPath = '/programRules';
ProgramRule = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ProgramRule);
var ProgramRule$1 = ProgramRule;
Factory.register(ProgramRule.type, ProgramRule);

var ProgramSummary = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ProgramSummary, _Base);

  function ProgramSummary() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ProgramSummary.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.pendingShareExpiration = attributes.pendingShareExpiration;
    this.pendingShares = attributes.pendingShares;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.activeShares = relationships.activeShares;
    this.referrals = relationships.referrals;
  };

  return ProgramSummary;
}(Base$1);

ProgramSummary.type = 'programSummary';
ProgramSummary.collectionPath = '/programSummaries';
ProgramSummary = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ProgramSummary);
var ProgramSummary$1 = ProgramSummary;
Factory.register(ProgramSummary.type, ProgramSummary);

var Promotion = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Promotion, _Base);

  function Promotion() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Promotion.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.active = attributes.active;
    this.basePromoId = attributes.basePromoId;
    this.expirationDate = attributes.expirationDate;
    this.expired = attributes.expired;
    this.issueDate = attributes.issueDate;
    this.redemptionDates = attributes.redemptionDates;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.user = relationships.user;
  };

  return Promotion;
}(Base$1);

Promotion.type = 'promotion';
Promotion.collectionPath = '/promotions';
Promotion = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Promotion);
var Promotion$1 = Promotion;
Factory.register(Promotion.type, Promotion);

var Referral = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Referral, _Base);

  function Referral() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Referral.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.createdAt = attributes.createdAt;
    this.shareId = attributes.shareId;
    this.state = attributes.state;
    this.visitorId = attributes.visitorId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.friend = relationships.friend;
  };

  return Referral;
}(Base$1);

Referral.type = 'referral';
Referral.collectionPath = '/referrals';
Referral = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Referral);
var Referral$1 = Referral;
Factory.register(Referral.type, Referral);

var RentalAvailability = /*#__PURE__*/function (_Base) {
  _inheritsLoose(RentalAvailability, _Base);

  function RentalAvailability() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = RentalAvailability.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.count = attributes.count;
    this.dateEnd = attributes.dateEnd;
    this.dateStart = attributes.dateStart;
    this.readyToShipCount = attributes.readyToShipCount;
    this.utilizationPercent = attributes.utilizationPercent;
    this.zipCode = attributes.zipCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.sku = relationships.sku;
  };

  return RentalAvailability;
}(Base$1);

RentalAvailability.type = 'rentalAvailability';
RentalAvailability.collectionPath = '/rentalAvailabilities';
RentalAvailability = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], RentalAvailability);
var RentalAvailability$1 = RentalAvailability;
Factory.register(RentalAvailability.type, RentalAvailability);

var ReplacementCollection = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ReplacementCollection, _Base);

  function ReplacementCollection() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ReplacementCollection.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.replacementTiming = attributes.replacementTiming;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.replacementOptions = relationships.replacementOptions;
  };

  return ReplacementCollection;
}(Base$1);

ReplacementCollection.type = 'replacement';
ReplacementCollection.collectionPath = '/replacements';
ReplacementCollection = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ReplacementCollection);
var ReplacementCollection$1 = ReplacementCollection;
Factory.register(ReplacementCollection.type, ReplacementCollection);

var ReplacementOption = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ReplacementOption, _Base);

  function ReplacementOption() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ReplacementOption.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.active = attributes.active;
    this.addedAt = attributes.addedAt;
    this.replacementCollectionId = attributes.replacementCollectionId;
    this.selectedSkus = attributes.selectedSkus;
    this.styleId = attributes.styleId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.product = relationships.product;
  };

  return ReplacementOption;
}(Base$1);

ReplacementOption.type = 'replacementCollectionMember';
ReplacementOption.collectionPath = '/replacementCollectionMembers';
ReplacementOption = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ReplacementOption);
var ReplacementOption$1 = ReplacementOption;
Factory.register(ReplacementOption.type, ReplacementOption);

var Reservation = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Reservation, _Base);

  function Reservation() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Reservation.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.backupHoldId = attributes.backupHoldId;
    this.date = attributes.date;
    this.duration = attributes.duration;
    this.price = attributes.price;
    this.primaryHoldId = attributes.primaryHoldId;
    this.zipCode = attributes.zipCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.backupSku = relationships.backupSku;
    this.primarySku = relationships.primarySku;
    this.user = relationships.user;
  };

  return Reservation;
}(Base$1);

Reservation.type = 'reservation';
Reservation.collectionPath = '/reservations';
Reservation = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Reservation);
var Reservation$1 = Reservation;
Factory.register(Reservation.type, Reservation);

var ReturnShippingLabel = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ReturnShippingLabel, _Base);

  function ReturnShippingLabel() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ReturnShippingLabel.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.depotId = attributes.depotId;
    this.fulfillmentGroupId = attributes.fulfillmentGroupId;
    this.orderGroupId = attributes.orderGroupId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return ReturnShippingLabel;
}(Base$1);

ReturnShippingLabel.type = 'returnShippingLabel';
ReturnShippingLabel.collectionPath = '/returnShippingLabels';
ReturnShippingLabel = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ReturnShippingLabel);
var ReturnShippingLabel$1 = ReturnShippingLabel;
Factory.register(ReturnShippingLabel.type, ReturnShippingLabel);

var ReviewerSummary = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ReviewerSummary, _Base);

  function ReviewerSummary() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ReviewerSummary.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.birthday = attributes.birthday;
    this.bodyType = attributes.bodyType;
    this.bustSize = attributes.bustSize;
    this.firstName = attributes.firstName;
    this.heightInches = attributes.heightInches;
    this.nickname = attributes.nickname;
    this.usStandardSize = attributes.usStandardSize;
    this.userId = attributes.userId;
    this.weightPounds = attributes.weightPounds;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return ReviewerSummary;
}(Base$1);

ReviewerSummary.type = 'reviewerSummary';
ReviewerSummary.collectionPath = '/reviewerSummaries';
ReviewerSummary = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ReviewerSummary);
var ReviewerSummary$1 = ReviewerSummary;
Factory.register(ReviewerSummary.type, ReviewerSummary);

var Reviews = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Reviews, _Base);

  function Reviews() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Reviews.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.caption = attributes.caption;
    this.content = attributes.content;
    this.coverPhotoId = attributes.coverPhotoId;
    this.eventType = attributes.eventType;
    this.featured = attributes.featured;
    this.firstName = attributes.firstName;
    this.fit = attributes.fit;
    this.numReviewsByUser = attributes.numReviewsByUser;
    this.photoIds = attributes.photoIds;
    this.rating = attributes.rating;
    this.reactionSummaries = attributes.reactionSummaries;
    this.reviewerSnapshot = attributes.reviewerSnapshot;
    this.sizeWorn = attributes.sizeWorn;
    this.staff = attributes.staff;
    this.status = attributes.status;
    this.styleName = attributes.styleName;
    this.uploadedAt = attributes.uploadedAt;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.photos = relationships.photos;
    this.reviewerSummaries = relationships.reviewerSummaries;
  };

  return Reviews;
}(Base$1);

Reviews.type = 'review';
Reviews.collectionPath = '/reviews';
Reviews = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Reviews);
var Reviews$1 = Reviews;
Factory.register(Reviews.type, Reviews);

var Reward = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Reward, _Base);

  function Reward() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Reward.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.maximumRedemptionsPerEligibility = attributes.maximumRedemptionsPerEligibility;
    this.name = attributes.name;
    this.promoCode = attributes.promoCode;
    this.recipientType = attributes.recipientType;
    this.redemptionsForReward = attributes.redemptionsForReward;
    this.rewardType = attributes.rewardType;
    this.slotCount = attributes.slotCount;
    this.termLength = attributes.termLength;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Reward;
}(Base$1);

Reward.type = 'reward';
Reward.collectionPath = '/rewards';
Reward = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Reward);
var Reward$1 = Reward;
Factory.register(Reward.type, Reward);

var RtrPassId = /*#__PURE__*/function (_Base) {
  _inheritsLoose(RtrPassId, _Base);

  function RtrPassId() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = RtrPassId.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.code = attributes.code;
    this.utcExpirationDate = attributes.utcExpirationDate;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return RtrPassId;
}(Base$1);

RtrPassId.type = 'rtrPassId';
RtrPassId.collectionPath = '/rtrPassIds';
RtrPassId = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], RtrPassId);
var RtrPassId$1 = RtrPassId;
Factory.register(RtrPassId.type, RtrPassId);

var RtrUpdateAvailability = /*#__PURE__*/function (_Base) {
  _inheritsLoose(RtrUpdateAvailability, _Base);

  function RtrUpdateAvailability() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = RtrUpdateAvailability.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.count = attributes.count;
    this.readyToShipCount = attributes.readyToShipCount;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.sku = relationships.sku;
  };

  return RtrUpdateAvailability;
}(Base$1);

RtrUpdateAvailability.type = 'rtrUpdateAvailability';
RtrUpdateAvailability.collectionPath = '/rtrUpdateAvailabilities';
RtrUpdateAvailability = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], RtrUpdateAvailability);
var RtrUpdateAvailability$1 = RtrUpdateAvailability;
Factory.register(RtrUpdateAvailability.type, RtrUpdateAvailability);

var SKU = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SKU, _Base);

  function SKU() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = SKU.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.canonicalSizes = attributes.canonicalSizes;
    this.size = attributes.size;
    this.styleName = attributes.styleName;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.bulkAvailabilities = relationships.bulkAvailabilities;
    this.clearanceAvailabilities = relationships.clearanceAvailabilities;
    this.fuzzyGiraffeAvailabilities = relationships.fuzzyGiraffeAvailabilities;
    this.product = relationships.product;
    this.rentalAvailabilities = relationships.rentalAvailabilities;
    this.rtrUpdateAvailabilities = relationships.rtrUpdateAvailabilities;
    this.unlimitedAvailabilities = relationships.unlimitedAvailabilities;
  };

  return SKU;
}(Base$1);

SKU.type = 'sku';
SKU.collectionPath = '/skus';
SKU = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], SKU);
var SKU$1 = SKU;
Factory.register(SKU.type, SKU);

var SailthruMarketing = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SailthruMarketing, _Base);

  function SailthruMarketing() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = SailthruMarketing.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.marketingOptOut = attributes.marketingOptOut;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {//noop
  };

  return SailthruMarketing;
}(Base$1);

SailthruMarketing.type = 'sailthruMarketing';
SailthruMarketing.collectionPath = '/sailthruMarketing';
SailthruMarketing = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], SailthruMarketing);
var SailthruMarketing$1 = SailthruMarketing;
Factory.register(SailthruMarketing.type, SailthruMarketing);

var SameDayDeliveryEligibility = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SameDayDeliveryEligibility, _Base);

  function SameDayDeliveryEligibility() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = SameDayDeliveryEligibility.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.newBagCutoff = attributes.newBagCutoff;
    this.newRentBegin = attributes.newRentBegin;
    this.sameDayDeliveryEligible = attributes.sameDayDeliveryEligible;
    this.zipCode = attributes.zipCode;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return SameDayDeliveryEligibility;
}(Base$1);

SameDayDeliveryEligibility.type = 'sameDayDeliveryEligibility';
SameDayDeliveryEligibility.collectionPath = '/isSameDayDeliveryEligible';
SameDayDeliveryEligibility = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], SameDayDeliveryEligibility);
var SameDayDeliveryEligibility$1 = SameDayDeliveryEligibility;
Factory.register(SameDayDeliveryEligibility.type, SameDayDeliveryEligibility);

var Segment = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Segment, _Base);

  function Segment() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Segment.prototype;

  ////////////////////
  //                //
  //   attributes   //
  //                //
  ////////////////////
  _proto.assignAttributes = function assignAttributes(_attributes) {// noop
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Segment;
}(Base$1);

Segment.type = 'segment';
Segment.collectionPath = '/segments';
Segment = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Segment);
var Segment$1 = Segment;
Factory.register(Segment.type, Segment);

var SelfServiceExchange = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SelfServiceExchange, _Base);

  function SelfServiceExchange() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = SelfServiceExchange.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.bagCutoffTime = attributes.bagCutoffTime;
    this.exchangeCutoffTime = attributes.exchangeCutoffTime;
    this.groupId = attributes.groupId;
    this.hasCompletedExchange = attributes.hasCompletedExchange;
    this.hasCompletedHappinessSurvey = attributes.hasCompletedHappinessSurvey;
    this.hasPreviousReplacement = attributes.hasPreviousReplacement;
    this.orderGroupSummary = attributes.orderGroupSummary;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return SelfServiceExchange;
}(Base$1);

SelfServiceExchange.type = 'selfServiceExchange';
SelfServiceExchange.collectionPath = '/selfServiceExchanges';
SelfServiceExchange = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], SelfServiceExchange);
var SelfServiceExchange$1 = SelfServiceExchange;
Factory.register(SelfServiceExchange.type, SelfServiceExchange);

var SelfServiceExchangeBag = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SelfServiceExchangeBag, _Base);

  function SelfServiceExchangeBag() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = SelfServiceExchangeBag.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.addressId = attributes.addressId;
    this.coverDifferenceWithCredits = attributes.coverDifferenceWithCredits;
    this.cutoffTime = attributes.cutoffTime;
    this.freeShipping = attributes.freeShipping;
    this.groupId = attributes.groupId;
    this.holdsToAdd = attributes.holdsToAdd;
    this.holdsToRemove = attributes.holdsToRemove;
    this.isBagConfirmation = attributes.isBagConfirmation;
    this.latestPossibleShipDate = attributes.latestPossibleShipDate;
    this.orderId = attributes.orderId;
    this.originalGroupId = attributes.originalGroupId;
    this.paymentMethodId = attributes.paymentMethodId;
    this.problemItemBookings = attributes.problemItemBookings;
    this.rentBegin = attributes.rentBegin;
    this.rentEnd = attributes.rentEnd;
    this.replacementBookings = attributes.replacementBookings;
    this.replacementCharge = attributes.replacementCharge;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.products = relationships.products;
  };

  return SelfServiceExchangeBag;
}(Base$1);

SelfServiceExchangeBag.type = 'selfServiceExchangeBag';
SelfServiceExchangeBag.collectionPath = '/selfServiceExchangeBags';
SelfServiceExchangeBag = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], SelfServiceExchangeBag);
var SelfServiceExchangeBag$1 = SelfServiceExchangeBag;
Factory.register(SelfServiceExchangeBag.type, SelfServiceExchangeBag);

var SelfServiceTransaction = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SelfServiceTransaction, _Base);

  function SelfServiceTransaction() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = SelfServiceTransaction.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.admin = attributes.admin;
    this.bookingIdToIgnore = attributes.bookingIdToIgnore;
    this.depotId = attributes.depotId;
    this.groupId = attributes.groupId;
    this.merchandiseCategory = attributes.merchandiseCategory;
    this.orderId = attributes.orderId;
    this.primaryHoldId = attributes.primaryHoldId;
    this.problemSwapRequests = attributes.problemSwapRequests;
    this.rentalEndDate = attributes.rentalEndDate;
    this.rentalStartDate = attributes.rentalStartDate;
    this.sku = attributes.sku;
    this.subType = attributes.subType;
    this.userId = attributes.userId;
    this.zipcode = attributes.zipcode;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return SelfServiceTransaction;
}(Base$1);

SelfServiceTransaction.type = 'selfServiceTransaction';
SelfServiceTransaction.collectionPath = '/selfServiceTransactions';
SelfServiceTransaction = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], SelfServiceTransaction);
var SelfServiceTransaction$1 = SelfServiceTransaction;
Factory.register(SelfServiceTransaction.type, SelfServiceTransaction);

var Share = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Share, _Base);

  function Share() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Share.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.advocateId = attributes.advocateId;
    this.createdAt = attributes.createdAt;
    this.email = attributes.email;
    this.expirationDate = attributes.expirationDate;
    this.link = attributes.link;
    this.programType = attributes.programType;
    this.sharedAt = attributes.sharedAt;
    this.subType = attributes.subType;
    this.target = attributes.target;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.advocate = relationships.advocate;
    this.referrals = relationships.referrals;
    this.visits = relationships.visits;
  };

  return Share;
}(Base$1);

Share.type = 'share';
Share.collectionPath = '/shares';
Share = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Share);
var Share$1 = Share;
Factory.register(Share.type, Share);

var ShareSummary = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ShareSummary, _Base);

  function ShareSummary() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ShareSummary.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.referralsCount = attributes.referralsCount;
    this.visitCount = attributes.visitCount;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.share = relationships.share;
  };

  return ShareSummary;
}(Base$1);

ShareSummary.type = 'shareSummary';
ShareSummary.collectionPath = '/shareSummaries';
ShareSummary = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ShareSummary);
var ShareSummary$1 = ShareSummary;
Factory.register(ShareSummary.type, ShareSummary);

var ShippingCutoff = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ShippingCutoff, _Base);

  function ShippingCutoff() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ShippingCutoff.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.cutoffTime = attributes.cutoffTime;
    this.deliveryDate = attributes.deliveryDate;
    this.shippingMethodId = attributes.shippingMethodId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return ShippingCutoff;
}(Base$1);

ShippingCutoff.type = 'shippingCutoff';
ShippingCutoff.collectionPath = '/shippingCutoffs';
ShippingCutoff = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], ShippingCutoff);
var ShippingCutoff$1 = ShippingCutoff;
Factory.register(ShippingCutoff.type, ShippingCutoff);

var Showroom = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Showroom, _Base);

  function Showroom() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Showroom.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.description = attributes.description;
    this.distanceFromShowroom = attributes.distanceFromShowroom;
    this.geoTargetDistance = attributes.geoTargetDistance;
    this.latitude = attributes.latitude;
    this.longitude = attributes.longitude;
    this.name = attributes.name;
    this.pickupFee = attributes.pickupFee;
    this.storePickupAvailable = attributes.storePickupAvailable;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.address = relationships.address;
  };

  return Showroom;
}(Base$1);

Showroom.type = 'showroom';
Showroom.collectionPath = '/showrooms';
Showroom = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Showroom);
var Showroom$1 = Showroom;
Factory.register(Showroom.type, Showroom);

var SizeScale = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SizeScale, _Base);

  function SizeScale() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = SizeScale.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.canonicalToRegional = attributes.canonicalToRegional;
    this.displayName = attributes.displayName;
    this.hasLengths = attributes.hasLengths;
    this.sizeNames = attributes.sizeNames;
    this.sizes = attributes.sizes;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return SizeScale;
}(Base$1);

SizeScale.type = 'sizeScale';
SizeScale.collectionPath = '/sizeScales';
SizeScale = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], SizeScale);
var SizeScale$1 = SizeScale;
Factory.register(SizeScale.type, SizeScale);

var SubscriptionCharge = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SubscriptionCharge, _Base);

  function SubscriptionCharge() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = SubscriptionCharge.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.membershipType = attributes.membershipType;
    this.preferences = attributes.preferences;
    this.subscriptionChargeAmount = attributes.subscriptionChargeAmount;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.membership = relationships.membership;
  };

  return SubscriptionCharge;
}(Base$1);

SubscriptionCharge.type = 'subscriptionCharge';
SubscriptionCharge.collectionPath = '/subscriptionCharges';
SubscriptionCharge = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], SubscriptionCharge);
var SubscriptionCharge$1 = SubscriptionCharge;
Factory.register(SubscriptionCharge.type, SubscriptionCharge);

var SubscriptionOrderConfirmation = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SubscriptionOrderConfirmation, _Base);

  function SubscriptionOrderConfirmation() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = SubscriptionOrderConfirmation.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.userId = attributes.userId;
    this.orderEmail = attributes.orderEmail;
    this.baseShipments = attributes.baseShipments;
    this.nextBillDate = attributes.nextBillDate;
    this.promoCode = attributes.promoCode;
    this.previews = attributes.previews;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return SubscriptionOrderConfirmation;
}(Base$1);

SubscriptionOrderConfirmation.type = 'subscriptionOrderConfirmation';
SubscriptionOrderConfirmation.collectionPath = '/subscriptionOrderConfirmations';
SubscriptionOrderConfirmation = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], SubscriptionOrderConfirmation);
var SubscriptionOrderConfirmation$1 = SubscriptionOrderConfirmation;
Factory.register(SubscriptionOrderConfirmation.type, SubscriptionOrderConfirmation);

var Token = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Token, _Base);

  function Token() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Token.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.authExpiresAt = attributes.authExpiresAt;
    this.expiresAt = attributes.expiresAt;
    this.token = attributes.token;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Token;
}(Base$1);

Token.type = 'authenticationToken';
Token.collectionPath = '/authenticationTokens';
Token = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Token);
var Token$1 = Token;
Factory.register(Token.type, Token);

var Total = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Total, _Base);

  function Total() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Total.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.grand = attributes.grand;
    this.insurance = attributes.insurance;
    this.preDiscountedInsurance = attributes.preDiscountedInsurance;
    this.preDiscountedShipping = attributes.preDiscountedShipping;
    this.prePromoSub = attributes.prePromoSub;
    this.promoItem = attributes.promoItem;
    this.shipping = attributes.shipping;
    this.slotProration = attributes.slotProration;
    this.sub = attributes.sub;
    this.tax = attributes.tax;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Total;
}(Base$1);

Total.type = 'total';
Total = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Total);
var Total$1 = Total;
Factory.register(Total.type, Total);

var Unknown = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Unknown, _Base);

  function Unknown() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Unknown.prototype;

  ////////////////////
  //                //
  //   attributes   //
  //                //
  ////////////////////
  _proto.assignAttributes = function assignAttributes(_attributes) {// noop
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Unknown;
}(Base$1);

Unknown.type = 'unknown';
Unknown.collectionPath = '/unknown';
Unknown = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Unknown);
var Unknown$1 = Unknown;
Factory.register(Unknown.type, Unknown);
Factory.FallbackType = Unknown;

var UnlimitedAvailability = /*#__PURE__*/function (_Base) {
  _inheritsLoose(UnlimitedAvailability, _Base);

  function UnlimitedAvailability() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = UnlimitedAvailability.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.count = attributes.count;
    this.readyToShipCount = attributes.readyToShipCount;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.sku = relationships.sku;
  };

  return UnlimitedAvailability;
}(Base$1);

UnlimitedAvailability.type = 'unlimitedAvailability';
UnlimitedAvailability.collectionPath = '/unlimitedAvailabilities';
UnlimitedAvailability = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], UnlimitedAvailability);
var UnlimitedAvailability$1 = UnlimitedAvailability;
Factory.register(UnlimitedAvailability.type, UnlimitedAvailability);

var UnlimitedItem = /*#__PURE__*/function (_Base) {
  _inheritsLoose(UnlimitedItem, _Base);

  function UnlimitedItem() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = UnlimitedItem.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.barcode = attributes.barcode;
    this.orderId = attributes.orderId;
    this.purchasePrice = attributes.purchasePrice;
    this.purchasePriceWithTax = attributes.purchasePriceWithTax;
    this.reservationId = attributes.reservationId;
    this.sku = attributes.sku;
    this.status = attributes.status;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.product = relationships.product;
  };

  return UnlimitedItem;
}(Base$1);

UnlimitedItem.type = 'unlimitedItem';
UnlimitedItem.collectionPath = '/unlimitedItems';
UnlimitedItem = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], UnlimitedItem);
var UnlimitedItem$1 = UnlimitedItem;
Factory.register(UnlimitedItem.type, UnlimitedItem);

var UnlimitedSunsetEducation = /*#__PURE__*/function (_Base) {
  _inheritsLoose(UnlimitedSunsetEducation, _Base);

  function UnlimitedSunsetEducation() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = UnlimitedSunsetEducation.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.userId = attributes.userId;
    this.wasUserAutoSunset = attributes.wasUserAutoSunset;
    this.wasUserUnlimitedPreviousTerm = attributes.wasUserUnlimitedPreviousTerm;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return UnlimitedSunsetEducation;
}(Base$1);

UnlimitedSunsetEducation.type = 'unlimitedSunsetEducation';
UnlimitedSunsetEducation.collectionPath = '/unlimitedSunsetEducation';
UnlimitedSunsetEducation = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], UnlimitedSunsetEducation);
var UnlimitedSunsetEducation$1 = UnlimitedSunsetEducation;
Factory.register(UnlimitedSunsetEducation.type, UnlimitedSunsetEducation);

var UnlimitedSunsetRecommendation = /*#__PURE__*/function (_Base) {
  _inheritsLoose(UnlimitedSunsetRecommendation, _Base);

  function UnlimitedSunsetRecommendation() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = UnlimitedSunsetRecommendation.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.highlightedTierId = attributes.highlightedTierId;
    this.maxItemsMonthly = attributes.maxItemsMonthly;
    this.minItemsMonthly = attributes.minItemsMonthly;
    this.recommendedTierId1 = attributes.recommendedTierId1;
    this.recommendedTierId2 = attributes.recommendedTierId2;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return UnlimitedSunsetRecommendation;
}(Base$1);

UnlimitedSunsetRecommendation.type = 'unlimitedSunsetRecommendation';
UnlimitedSunsetRecommendation.collectionPath = '/unlimitedSunsetRecommendation';
UnlimitedSunsetRecommendation = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], UnlimitedSunsetRecommendation);
var UnlimitedSunsetRecommendation$1 = UnlimitedSunsetRecommendation;
Factory.register(UnlimitedSunsetRecommendation.type, UnlimitedSunsetRecommendation);

var User = /*#__PURE__*/function (_Base) {
  _inheritsLoose(User, _Base);

  function User() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = User.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.accountType = attributes.accountType;
    this.aggregateType = attributes.aggregateType;
    this.bodyType = attributes.bodyType;
    this.bustSize = attributes.bustSize;
    this.cellPhoneNotify = attributes.cellPhoneNotify;
    this.cellPhoneNumber = attributes.cellPhoneNumber;
    this.created = attributes.created;
    this.dateOfBirth = attributes.dateOfBirth;
    this.email = attributes.email;
    this.firstName = attributes.firstName;
    this.height = attributes.height;
    this.isAdmin = attributes.isAdmin;
    this.isCustomer = attributes.isCustomer;
    this.isEmailVerified = attributes.isEmailVerified;
    this.isPasswordSet = attributes.isPasswordSet;
    this.lastName = attributes.lastName;
    this.updated = attributes.updated;
    this.weight = attributes.weight;
    this.zipCode = attributes.zipCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.addresses = relationships.addresses;
    this.componentViews = relationships.componentViews;
    this.eventSelections = relationships.eventSelections;
    this.eventTypeRecos = relationships.eventTypeRecos;
    this.experiments = relationships.experiments;
    this.hearts = relationships.hearts;
    this.memberHistoryStats = relationships.memberHistoryStats;
    this.membershipItems = relationships.membershipItems;
    this.membershipStates = relationships.membershipStates;
    this.memberships = relationships.memberships;
    this.paymentMethods = relationships.paymentMethods;
    this.productCollections = relationships.productCollections;
    this.productRecos = relationships.productRecos;
    this.profiles = relationships.profiles;
    this.promotions = relationships.promotions;
    this.reviewSummary = relationships.reviewSummary;
    this.rtrPassId = relationships.rtrPassId;
    this.sailthruMarketing = relationships.sailthruMarketing;
    this.segments = relationships.segments;
    this.userSelections = relationships.userSelections;
  };

  return User;
}(Base$1);

User.type = 'user';
User.collectionPath = '/users';
User = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], User);
var User$1 = User;
Factory.register(User.type, User);

var UserEmail = /*#__PURE__*/function (_Base) {
  _inheritsLoose(UserEmail, _Base);

  function UserEmail() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = UserEmail.prototype;

  ////////////////////
  //                //
  //   attributes   //
  //                //
  ////////////////////
  _proto.assignAttributes = function assignAttributes(_attributes) {// noop
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.user = relationships.user;
  };

  return UserEmail;
}(Base$1);

UserEmail.type = 'user-email';
UserEmail.collectionPath = '/user-emails';
UserEmail = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], UserEmail);
var UserEmail$1 = UserEmail;
Factory.register(UserEmail.type, UserEmail);

var WatchlistNotificationRule = /*#__PURE__*/function (_Base) {
  _inheritsLoose(WatchlistNotificationRule, _Base);

  function WatchlistNotificationRule() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = WatchlistNotificationRule.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.snoozePeriod = attributes.snoozePeriod;
    this.snoozeUntil = attributes.snoozeUntil;
    this.userId = attributes.userId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
  };

  return WatchlistNotificationRule;
}(Base$1);

WatchlistNotificationRule.type = 'watchlistNotificationRule';
WatchlistNotificationRule.collectionPath = '/watchlistNotificationRules';
WatchlistNotificationRule = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], WatchlistNotificationRule);
var WatchlistNotificationRule$1 = WatchlistNotificationRule;
Factory.register(WatchlistNotificationRule.type, WatchlistNotificationRule);

var ProductRatingActions;

(function (ProductRatingActions) {
  ProductRatingActions["FAVORITE_ACTION"] = "HEARTED";
  ProductRatingActions["DOWNVOTE_ACTION"] = "DOWNVOTED";
})(ProductRatingActions || (ProductRatingActions = {}));

var UserProductRating = /*#__PURE__*/function (_Base) {
  _inheritsLoose(UserProductRating, _Base);

  function UserProductRating() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = UserProductRating.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.action = attributes.action;
    this.styleId = attributes.styleId;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.product = relationships.product;
  };

  return UserProductRating;
}(Base$1);

UserProductRating.type = 'userProductRating';
UserProductRating.collectionPath = '/userProductRatings';
UserProductRating = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], UserProductRating);
var UserProductRating$1 = UserProductRating;
Factory.register(UserProductRating.type, UserProductRating);

var UserProfile = /*#__PURE__*/function (_Base) {
  _inheritsLoose(UserProfile, _Base);

  function UserProfile() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = UserProfile.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.backupSize = attributes.backupSize;
    this.cellPhoneNotify = attributes.cellPhoneNotify;
    this.dueDate = attributes.dueDate;
    this.exposurePreferences = attributes.exposurePreferences;
    this.facebookId = attributes.facebookId;
    this.favoriteColors = attributes.favoriteColors;
    this.favoriteDesigners = attributes.favoriteDesigners;
    this.googleId = attributes.googleId;
    this.inMaternity = attributes.inMaternity;
    this.lbdStyleName = attributes.lbdStyleName;
    this.outfitStyleNames = attributes.outfitStyleNames;
    this.pantSize = attributes.pantSize;
    this.primarySize = attributes.primarySize;
    this.problemAreas = attributes.problemAreas;
    this.smsOptIn = attributes.smsOptIn;
    this.weddingStyleName = attributes.weddingStyleName;
    this.zipCode = attributes.zipCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.addresses = relationships.addresses;
    this.paymentMethods = relationships.paymentMethods;
  };

  return UserProfile;
}(Base$1);

UserProfile.type = 'userProfile';
UserProfile.collectionPath = '/userProfiles';
UserProfile = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], UserProfile);
var UserProfile$1 = UserProfile;
Factory.register(UserProfile.type, UserProfile);

var UserReviewSummary = /*#__PURE__*/function (_Base) {
  _inheritsLoose(UserReviewSummary, _Base);

  function UserReviewSummary() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = UserReviewSummary.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.reviewCount = attributes.reviewCount;
    this.photoCount = attributes.photoCount;
    this.commentCount = attributes.commentCount;
    this.complimentCount = attributes.complimentCount;
    this.rentalsOrdering = attributes.rentalsOrdering;
    this.styles = attributes.styles;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return UserReviewSummary;
}(Base$1);

UserReviewSummary.type = 'userReviewSummary';
UserReviewSummary.collectionPath = '/userReviewSummaries';
UserReviewSummary = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], UserReviewSummary);
var UserReviewSummary$1 = UserReviewSummary;
Factory.register(UserReviewSummary.type, UserReviewSummary);

var UserSelection = /*#__PURE__*/function (_Base) {
  _inheritsLoose(UserSelection, _Base);

  function UserSelection() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = UserSelection.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.bride = attributes.bride;
    this.canonicalSizeList = attributes.canonicalSizeList;
    this.created = attributes.created;
    this.dueDate = attributes.dueDate;
    this.eventTypeId = attributes.eventTypeId;
    this.graduationDate = attributes.graduationDate;
    this.inCollege = attributes.inCollege;
    this.inMaternity = attributes.inMaternity;
    this.rentalStartDate = attributes.rentalStartDate;
    this.source = attributes.source;
    this.upsellSourcedStyle = attributes.upsellSourcedStyle;
    this.weddingDate = attributes.weddingDate;
    this.zipCode = attributes.zipCode;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.eventType = relationships.eventType;
  };

  return UserSelection;
}(Base$1);

UserSelection.type = 'userSelection';
UserSelection.collectionPath = '/userSelections';
UserSelection = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], UserSelection);
var UserSelection$1 = UserSelection;
Factory.register(UserSelection.type, UserSelection);

var UserStylePreferences = /*#__PURE__*/function (_Base) {
  _inheritsLoose(UserStylePreferences, _Base);

  function UserStylePreferences() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = UserStylePreferences.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.stylePreferences = attributes.stylePreferences;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return UserStylePreferences;
}(Base$1);

UserStylePreferences.type = 'userStylePreferences';
UserStylePreferences.collectionPath = '/userStylePreferences';
UserStylePreferences = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], UserStylePreferences);
var UserStylePreferences$1 = UserStylePreferences;
Factory.register(UserStylePreferences.type, UserStylePreferences);

var Visit = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Visit, _Base);

  function Visit() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Visit.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.browserId = attributes.browserId;
    this.createdAt = attributes.createdAt;
    this.shareId = attributes.shareId;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.friend = relationships.friend;
  };

  return Visit;
}(Base$1);

Visit.type = 'visit';
Visit.collectionPath = '/visits';
Visit = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Visit);
var Visit$1 = Visit;
Factory.register(Visit.type, Visit);

var Waitlist = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Waitlist, _Base);

  function Waitlist() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Waitlist.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.cancelDate = attributes.cancelDate;
    this.converted = attributes.converted;
    this.convertedDate = attributes.convertedDate;
    this.membershipType = attributes.membershipType;
    this.modifiedTime = attributes.modifiedTime;
    this.paymentMethodId = attributes.paymentMethodId;
    this.paymentProfileId = attributes.paymentProfileId;
    this.signupTime = attributes.signupTime;
    this.userId = attributes.userId;
    this.waitlistId = attributes.waitlistId;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return Waitlist;
}(Base$1);

Waitlist.type = 'waitlist';
Waitlist.collectionPath = '/waitlists';
Waitlist = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], Waitlist);
var Waitlist$1 = Waitlist;
Factory.register(Waitlist.type, Waitlist);

var WaitlistEligibility = /*#__PURE__*/function (_Base) {
  _inheritsLoose(WaitlistEligibility, _Base);

  function WaitlistEligibility() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = WaitlistEligibility.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.eligible = attributes.eligible;
    this.status = attributes.status;
    this.userId = attributes.userId;
  };

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return;
    this.waitlist = relationships.waitlist;
  };

  return WaitlistEligibility;
}(Base$1);

WaitlistEligibility.type = 'waitlistEligibility';
WaitlistEligibility.collectionPath = '/waitlistEligibilities';
WaitlistEligibility = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], WaitlistEligibility);
var WaitlistEligibility$1 = WaitlistEligibility;
Factory.register(WaitlistEligibility.type, WaitlistEligibility);

var AnonymousUser = /*#__PURE__*/function (_Base) {
  _inheritsLoose(AnonymousUser, _Base);

  function AnonymousUser() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = AnonymousUser.prototype;

  ////////////////////
  //                //
  //   attributes   //
  //                //
  ////////////////////
  _proto.assignAttributes = function assignAttributes(_attributes) {// noop
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  ;

  _proto.assignRelationships = function assignRelationships(_relationships) {// noop
  };

  return AnonymousUser;
}(Base$1);

AnonymousUser.type = 'anonymousUser';
AnonymousUser.collectionPath = '/anonymousUser';
AnonymousUser = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], AnonymousUser);
var AnonymousUser$1 = AnonymousUser;
Factory.register(AnonymousUser.type, AnonymousUser);

var MarketData = /*#__PURE__*/function (_Base) {
  _inheritsLoose(MarketData, _Base);

  function MarketData() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = MarketData.prototype;

  _proto.assignAttributes = function assignAttributes(attributes) {
    if (!attributes) return;
    this.type = attributes.type;
    this.userId = attributes.userId;
    this.phoneNumber = attributes.phoneNumber;
    this.email = attributes.email;
    this.intent = attributes.intent;
    this.emailOptIn = attributes.emailOptIn;
    this.phoneOptIn = attributes.phoneOptIn;
  } ///////////////////////
  //                   //
  //   relationships   //
  //                   //
  ///////////////////////
  // no relationships
  ;

  _proto.assignRelationships = function assignRelationships(relationships) {
    if (!relationships) return; // no relationships
  };

  return MarketData;
}(Base$1);

MarketData.type = 'marketingData';
MarketData.collectionPath = '/marketingData';
MarketData = /*#__PURE__*/__decorate([/*#__PURE__*/staticImplements()], MarketData);
var MarketData$1 = MarketData;
Factory.register(MarketData.type, MarketData);

export { Activity$1 as Activity, Address$1 as Address, AddressSuggestion$1 as AddressSuggestion, AdvocateAwardStatus$1 as AdvocateAwardStatus, AdvocateEligibility$1 as AdvocateEligibility, AdvocateProgramStatus$1 as AdvocateProgramStatus, AggregateUserType$1 as AggregateUserType, AnonymousCheckout$1 as AnonymousCheckout, AnonymousUser$1 as AnonymousUser, AttributionSurvey$1 as AttributionSurvey, Authentication$1 as Authentication, AuthenticationAttempt$1 as AuthenticationAttempt, AuthenticationResponseError, AuthorizationResponseError, AvailableStartDate$1 as AvailableStartDate, Award$1 as Award, Bag$1 as Bag, BagGroup$1 as BagGroup, BagItem$1 as BagItem, Base$1 as Base, BlackoutDay$1 as BlackoutDay, Booking$1 as Booking, BulkAvailability$1 as BulkAvailability, Carousel$1 as Carousel, CarouselInteraction$1 as CarouselInteraction, Checkout$1 as Checkout, ClearanceAvailability$1 as ClearanceAvailability, CmsComponent$1 as CmsComponent, ComponentView$1 as ComponentView, CrossShipReturnByDateForToday$1 as CrossShipReturnByDateForToday, Curation$1 as Curation, CustomerChannelAttributionSurveyOption$1 as CustomerChannelAttributionSurveyOption, CustomerComment$1 as CustomerComment, CustomerPromiseItemSwapAction$1 as CustomerPromiseItemSwapAction, Designer$1 as Designer, DismissableModal$1 as DismissableModal, EventSelection$1 as EventSelection, EventType$1 as EventType, Experiment$1 as Experiment, ExpressCheckout$1 as ExpressCheckout, Flag$1 as Flag, FuzzyGiraffeAvailability$1 as FuzzyGiraffeAvailability, GiftCard$1 as GiftCard, GiftCardVerificationMethod$1 as GiftCardVerificationMethod, GodmotherError, GroupInvoice$1 as GroupInvoice, HappinessSurvey$1 as HappinessSurvey, Heart$1 as Heart, HomePickupPostalCode$1 as HomePickupPostalCode, HomePickupPostalCodeGroup$1 as HomePickupPostalCodeGroup, Invoice$1 as Invoice, ItemPurchaseCharge$1 as ItemPurchaseCharge, ItemReturnPromiseCollection$1 as ItemReturnPromiseCollection, LimitedAccountCompletion$1 as LimitedAccountCompletion, LineItemInvoice$1 as LineItemInvoice, LoyaltyAward$1 as LoyaltyAward, MarketData$1 as MarketData, Membership$1 as Membership, MembershipAction$1 as MembershipAction, MembershipActionCollection$1 as MembershipActionCollection, MembershipAnswer$1 as MembershipAnswer, MembershipBag$1 as MembershipBag, MembershipChangePlan$1 as MembershipChangePlan, MembershipChangeTierCharge$1 as MembershipChangeTierCharge, MembershipChangeTierPaymentOrderRequest$1 as MembershipChangeTierPaymentOrderRequest, MembershipChangeTierRequest$1 as MembershipChangeTierRequest, MembershipCharge$1 as MembershipCharge, MembershipEligibleForImmediateUpgrades$1 as MembershipEligibleForImmediateUpgrades, MembershipItemKept$1 as MembershipItemKept, MembershipPaymentOrder$1 as MembershipPaymentOrder, MembershipRentalBegin$1 as MembershipRentalBegin, MembershipState$1 as MembershipState, MembershipTier$1 as MembershipTier, MembershipTierChangePreview$1 as MembershipTierChangePreview, MembershipUndoChangeTierRequest$1 as MembershipUndoChangeTierRequest, Factory as ModelFactory, MomentReview$1 as MomentReview, NotifyMe$1 as NotifyMe, OnboardingQuizResponse$1 as OnboardingQuizResponse, OnboardingQuizResult$1 as OnboardingQuizResult, Order$1 as Order, OrderConfirmationSummary$1 as OrderConfirmationSummary, OrderConversionData$1 as OrderConversionData, OrderGroup$1 as OrderGroup, OrderInvoice$1 as OrderInvoice, OrderItem$1 as OrderItem, OrderTrackingData$1 as OrderTrackingData, Participant$1 as Participant, Partition$1 as Partition, PasswordResetCompletion$1 as PasswordResetCompletion, PasswordResetInitiation$1 as PasswordResetInitiation, PaymentMethod$1 as PaymentMethod, Photo$1 as Photo, PlacedOrder$1 as PlacedOrder, Price$1 as Price, Product$1 as Product, ProductCategory$1 as ProductCategory, ProductCollection$1 as ProductCollection, ProductCollectionMember$1 as ProductCollectionMember, ProductCollectionRejectedMember$1 as ProductCollectionRejectedMember, ProductExtra$1 as ProductExtra, ProductFitIssueRate$1 as ProductFitIssueRate, ProductRatingActions, ProductRatingSummary$1 as ProductRatingSummary, ProductReco$1 as ProductReco, ProgramRule$1 as ProgramRule, ProgramSummary$1 as ProgramSummary, Promotion$1 as Promotion, Referral$1 as Referral, RentalAvailability$1 as RentalAvailability, ReplacementCollection$1 as ReplacementCollection, ReplacementOption$1 as ReplacementOption, Reservation$1 as Reservation, ResponseError, ReturnShippingLabel$1 as ReturnShippingLabel, ReviewerSummary$1 as ReviewerSummary, Reviews$1 as Reviews, Reward$1 as Reward, RtrPassId$1 as RtrPassId, RtrUpdateAvailability$1 as RtrUpdateAvailability, SKU$1 as SKU, SailthruMarketing$1 as SailthruMarketing, SameDayDeliveryEligibility$1 as SameDayDeliveryEligibility, Segment$1 as Segment, SelfServiceExchange$1 as SelfServiceExchange, SelfServiceExchangeBag$1 as SelfServiceExchangeBag, SelfServiceTransaction$1 as SelfServiceTransaction, Share$1 as Share, ShareSummary$1 as ShareSummary, ShippingCutoff$1 as ShippingCutoff, Showroom$1 as Showroom, SizeScale$1 as SizeScale, SubscriptionCharge$1 as SubscriptionCharge, SubscriptionOrderConfirmation$1 as SubscriptionOrderConfirmation, Token$1 as Token, Total$1 as Total, Unknown$1 as Unknown, UnlimitedAvailability$1 as UnlimitedAvailability, UnlimitedItem$1 as UnlimitedItem, UnlimitedSunsetEducation$1 as UnlimitedSunsetEducation, UnlimitedSunsetRecommendation$1 as UnlimitedSunsetRecommendation, User$1 as User, UserEmail$1 as UserEmail, UserProductRating$1 as UserProductRating, UserProfile$1 as UserProfile, UserReviewSummary$1 as UserReviewSummary, UserSelection$1 as UserSelection, UserStylePreferences$1 as UserStylePreferences, Visit$1 as Visit, Waitlist$1 as Waitlist, WaitlistEligibility$1 as WaitlistEligibility, WatchlistNotificationRule$1 as WatchlistNotificationRule };
//# sourceMappingURL=godmother.esm.js.map
